import { mobileWorkflowDisplayKeys, mobileWorkflowDisplay, orderWorkflowNodeText } from "../order/index.js";
import { productFactText } from "../../services/product-display-values.js";
// 公共与导航统一入口：语言字段在同目录维护，逻辑与显示映射在此集中管理。
import * as simplified from "./zh-CN.js";
import * as traditional from "./zh-HK.js";
import * as english from "./en-US.js";
import { normalizeUiLocale, UI_LOCALES } from "../catalog.js";
export const zhCN = simplified.messages;
export const zhHK = traditional.messages;
export const enUS = english.messages;

// 分区导出保留原有接口，词条只在语言文件中保存一份。
export const devUpdatesZhCN = simplified.systemFeedback;
export const devUpdatesZhHK = traditional.systemFeedback;
export const devUpdatesEnUS = english.systemFeedback;
export const devSync20261013ZhCN = simplified.formDisplay;
export const devSync20261013ZhHK = traditional.formDisplay;
export const devSync20261013EnUS = english.formDisplay;
export const devSync20261015ZhCN = simplified.catalogDisplay;
export const devSync20261015ZhHK = traditional.catalogDisplay;
export const devSync20261015EnUS = english.catalogDisplay;
export const remainingBusinessZhCN = simplified.business;
export const remainingBusinessZhHK = traditional.business;
export const remainingBusinessEnUS = english.business;

export const fixedLabelKeys = Object.freeze({
  "先搜AI加载中…": "devOct15.aiLoading",
  对话主题和语音工具栏: "devOct15.conversationToolbar",
  "正在连接 AI 助手…": "devOct15.aiConnecting",
  更多卖家资料: "devOct15.moreSeller",
  "参数来源：题库标准答案。说明内容由 AI 根据参数生成，待确认；通用建议不代表该型号规格书结论。":
    "devOct15.standardDisclaimer",
  查看百科资料: "devOct15.viewWiki",
  存储器模块: "devOct15.modules",
  "存储器接口 / 控制器": "devOct15.controllers",
  非易失存储器: "devOct15.nonvolatile",
  其他存储器: "devOct15.otherMemory",
});

// 仅匹配已登记的系统固定文案，未知业务原文不转换。
const devUpdateKeyIndex = Object.freeze({
  // 资金与订单枚举的显示投影；原始状态码、name和提交值不变。
  已到账: "wallet.received",
  未知类型: "pcBrand.unknownType",
  采购: "mobileOrder.buy",
  销售: "mobileOrder.sell",
  邮箱: "accountSettings.personal.email",
  手机: "adminFlows.mobilePhones",
  大宗商品发布: "devUpdates.oct23BulkPublish",
  // 本次合并仅登记固定选项，未知商品、企业及用户原文不猜译。
  "Google 注册": "devUpdates.oct23GoogleSignUp",
  "Google 登录": "devUpdates.oct23GoogleSignIn",
  "不上传文件时，请填写发货备注": "devUpdates.oct23ShippingRemarkRequired",
  买家佣金: "devUpdates.oct23BuyerCommission",
  付款详情: "devUpdates.oct23PaymentDetails",
  付款金额: "devUpdates.oct23PaymentAmount",
  信用还款: "devUpdates.oct23CreditRepayment",
  信用额度: "devUpdates.oct23CreditLimit",
  关联业务单号: "devUpdates.oct23LinkedBusinessNumber",
  卖方货源价格: "devUpdates.oct23SellerSourcePrice",
  历史价格信息: "devUpdates.oct23PriceHistory",
  原价: "devUpdates.oct23PreviousPrice",
  原数量: "devUpdates.oct23PreviousQuantity",
  去还款: "devUpdates.oct23Repay",
  发货凭证上传成功: "devUpdates.oct23ShippingProofUploaded",
  发货凭证文件: "devUpdates.oct23ShippingProofFile",
  发货备注: "devUpdates.oct23ShippingRemark",
  发货详情: "devUpdates.oct23ShipmentDetails",
  变动金额: "devUpdates.oct23ChangedAmount",
  同意: "devUpdates.oct23Agree",
  否: "devUpdates.oct23No",
  "商品已有谈判人接单，请联系谈判人修改":
    "devUpdates.oct23ClaimedGoodsEditHint",
  商品总价: "devUpdates.oct23ProductTotal",
  "商品总金额：": "devUpdates.oct23ProductTotalPrefix",
  商品拆单: "devUpdates.oct23SplitProduct",
  商品结单: "devUpdates.oct23SettleProduct",
  填写收货信息: "devUpdates.oct23RecipientForm",
  备注说明: "devUpdates.oct23RemarkDescription",
  审核结果: "devUpdates.oct23ReviewDecision",
  审核记录: "devUpdates.oct23ReviewHistory",
  已提现金额: "devUpdates.oct23WithdrawnAmount",
  已确认购买意向单: "devUpdates.oct23ConfirmedPurchaseIntention",
  平台登录密码: "devUpdates.oct23PlatformPassword",
  应付总价: "devUpdates.oct23TotalPayable",
  开户行: "devUpdates.oct23Bank",
  开户行名称: "devUpdates.oct23BankName",
  当前可提现余额: "devUpdates.oct23AvailableWithdrawalBalance",
  待买家修改购买意向单: "devUpdates.oct23BuyerRevisionPending",
  待修改购买意向单: "devUpdates.oct23IntentionRevisionPending",
  待确认购买意向单: "devUpdates.oct23IntentionConfirmationPending",
  待货主确认购买意向单: "devUpdates.oct23SellerIntentionPending",
  待还信用金额: "devUpdates.oct23CreditOutstanding",
  "微信号（选填）": "devUpdates.oct23OptionalWechat",
  拆单数量: "devUpdates.oct23SplitQuantity",
  接单: "devUpdates.oct23Claim",
  接单成功: "devUpdates.oct23Claimed",
  提交本人有效身份证件照片: "devUpdates.oct23IdentityPhotoHint",
  提交购买意向单价格: "devUpdates.oct23SubmitIntentionPrice",
  提现审核: "devUpdates.oct23WithdrawalReview",
  提现明细: "devUpdates.oct23WithdrawalHistory",
  提现流水号: "devUpdates.oct23WithdrawalReference",
  提现状态: "devUpdates.oct23WithdrawalStatus",
  提现申请已提交: "devUpdates.oct23WithdrawalSubmitted",
  "提现记录缺少 ID，无法提交付款凭证":
    "devUpdates.oct23WithdrawalIdProofRequired",
  "提现记录缺少 ID，无法提交审核": "devUpdates.oct23WithdrawalIdReviewRequired",
  "提现记录缺少 ID，无法确认收款":
    "devUpdates.oct23WithdrawalIdReceiptRequired",
  提现详情: "devUpdates.oct23WithdrawalDetails",
  提现金额: "devUpdates.oct23WithdrawalAmount",
  支出明细: "devUpdates.oct23ExpenseHistory",
  支出明细详情: "devUpdates.oct23ExpenseDetails",
  收款人姓名: "devUpdates.oct23PayeeName",
  "整单提交，无需选择规格": "devUpdates.oct23WholeOrderHint",
  是: "devUpdates.oct23Yes",
  是否整单: "devUpdates.oct23WholeOrder",
  暂无上传凭证或备注: "devUpdates.oct23NoProofOrRemark",
  暂无子商品数据: "devUpdates.oct23NoChildProducts",
  暂无审核记录: "devUpdates.oct23NoReviewHistory",
  暂无规格数据: "devUpdates.oct23NoSpecifications",
  最近五条提现申请及处理进度: "devUpdates.oct23RecentWithdrawals",
  查看关联订单并填写本次结单金额: "devUpdates.oct23SettlementHint",
  流水号: "devUpdates.oct23Reference",
  海外用户可使用护照或当地政府签发的身份证件:
    "devUpdates.oct23OverseasDocumentHint",
  现价: "devUpdates.oct23CurrentPrice",
  生成合同价格: "devUpdates.oct23ContractPrice",
  申请提现: "devUpdates.oct23RequestWithdrawal",
  监督人和验货人: "devUpdates.oct23SupervisorInspector",
  确定接单: "devUpdates.oct23ConfirmClaim",
  确认意向单价格: "devUpdates.oct23ConfirmIntentionPrice",
  确认收款成功: "devUpdates.oct23ReceiptConfirmed",
  确认还款: "devUpdates.oct23ConfirmRepayment",
  结单: "devUpdates.oct23Settle",
  结单成功: "devUpdates.oct23Settled",
  结单金额: "devUpdates.oct23SettlementAmount",
  结单金额不能超过商品总金额: "devUpdates.oct23SettlementExceedsTotal",
  "缺少商品ID，无法查询关联订单": "devUpdates.oct23ProductIdRequired",
  认证地区: "devUpdates.oct23VerificationRegion",
  "该商品已拆分，不可整单": "devUpdates.oct23SplitWholeOrderUnavailable",
  "该邮箱已有平台账号，请输入原平台登录密码以绑定 Google。":
    "devUpdates.oct23GoogleBindingHint",
  请上传发货凭证文件或填写发货备注:
    "devUpdates.oct23ShippingProofOrRemarkRequired",
  请上传证件照片: "devUpdates.oct23IdentityPhotoRequired",
  请上传身份证国徽面: "devUpdates.oct23IdentityBackRequired",
  请先完成采购订单: "devUpdates.oct23PurchaseOrderRequired",
  "请确认提现款项已经到账，确认后状态将更新为已到账。":
    "devUpdates.oct23ConfirmWithdrawalReceipt",
  请联系谈判人修改: "devUpdates.oct23ContactNegotiator",
  "请输入 Swift Code": "devUpdates.oct23EnterSwiftCode",
  请输入买家手机号: "devUpdates.oct23EnterBuyerMobile",
  请输入商品总金额: "devUpdates.oct23EnterProductTotal",
  "请输入大于 100 的还款金额": "devUpdates.oct23RepaymentMinimum",
  请输入开户行名称: "devUpdates.oct23EnterBankName",
  请输入提现金额: "devUpdates.oct23EnterWithdrawalAmount",
  请输入收款人姓名: "devUpdates.oct23EnterPayeeName",
  请输入收货地址: "devUpdates.oct23EnterRecipientAddress",
  请输入收货电话: "devUpdates.oct23EnterRecipientPhone",
  请输入本人常用手机号: "devUpdates.oct23EnterOwnMobile",
  请输入本人常用邮箱: "devUpdates.oct23EnterOwnEmail",
  请输入正确的结单金额: "devUpdates.oct23InvalidSettlement",
  请输入现价: "devUpdates.oct23EnterCurrentPrice",
  请输入结单金额: "devUpdates.oct23EnterSettlement",
  账户余额变动与资金流向记录: "devUpdates.oct23BalanceHistoryHint",
  货主佣金: "devUpdates.oct23SellerCommission",
  资金方向: "devUpdates.oct23FundDirection",
  跟单详情: "devUpdates.oct23FollowDetails",
  转账凭证: "devUpdates.oct23TransferProof",
  还款成功: "devUpdates.oct23Repaid",
  还款金额: "devUpdates.oct23RepaymentAmount",
  选择提现币种: "devUpdates.oct23SelectWithdrawalCurrency",
  选择结单金额单位: "devUpdates.oct23SelectSettlementUnit",
  "重新连接 Google": "devUpdates.oct23ReconnectGoogle",
  金额类型: "devUpdates.oct23AmountType",
  验证已有平台账号: "devUpdates.oct23VerifyExistingAccount",
  验证并登录: "devUpdates.oct23VerifyAndSignIn",
  "（支持图片、视频等文件，文件或备注至少填写一项）":
    "devUpdates.oct23ProofFormatsHint",
  "（采购订单未完成）": "devUpdates.oct23PurchaseOrderIncomplete",
  必填项: "mobile.product.requiredField",
  请输入正整数: "adminFlows.enterAPositiveInteger",
  请填写有效的数字: "mobile.product.enterValidNumber",
  "正在验证 Google 账号…": "devUpdates.oct23GoogleVerifying",
  "正在连接 Google…": "devUpdates.oct23GoogleConnecting",
  "正在验证 Google 账号": "devUpdates.oct23GoogleVerifyingShort",
  "正在连接 Google": "devUpdates.oct23GoogleConnectingShort",
  "Google 登录配置暂不可用": "devUpdates.oct23GoogleConfigUnavailable",
  "Google 登录初始化失败": "devUpdates.oct23GoogleInitializationFailed",
  "Google 登录失败，请重试": "devUpdates.oct23GoogleLoginFailed",
  接单失败: "devUpdates.oct23ClaimFailed",
  "接单失败，请稍后重试": "devUpdates.oct23ClaimRetry",
  常用邮箱: "auth.email",
  本人手机号: "devUpdates.oct23OwnMobile",
  "请验证{method}并上传本人有效身份证件，确保填写信息与证件一致。":
    "devUpdates.oct23VerifyIdentityInstructions",
  "{method}校验通过后完成实名认证":
    "devUpdates.oct23IdentityVerificationCompletion",
  证件资料页: "devUpdates.oct23DocumentPage",
  "包含姓名、照片与证件号码的一面": "devUpdates.oct23DocumentPageHint",
  上传证件资料页: "devUpdates.oct23UploadDocumentPage",
  "证件背面（选填）": "devUpdates.oct23OptionalDocumentBack",
  证件存在背面信息时请上传: "devUpdates.oct23DocumentBackHint",
  上传证件背面: "devUpdates.oct23UploadDocumentBack",
  证件号码: "devUpdates.oct23DocumentNumber",
  请输入护照或当地身份证件号码: "devUpdates.oct23EnterOverseasDocument",
  请输入4位邮箱验证码: "devUpdates.oct23EnterEmailCode",
  请填写4位邮箱验证码: "devUpdates.oct23EmailCodeRequired",
  请填写4至6位短信验证码: "devUpdates.oct23SmsCodeRequired",
  请输入正确的证件号码: "devUpdates.oct23VerificationDocumentInvalid",
  请填写正确的手机号码: "devUpdates.oct23MobileInvalid",
  请填写正确的邮箱: "devUpdates.oct23EmailInvalid",
  背面可选: "devUpdates.oct23BackOptional",
  港澳台及海外: "auth.overseas",
  "邮件已发送，请注意查收": "devUpdates.oct23EmailSent",
  "短信已发送，请注意查收": "devUpdates.oct23SmsSent",
  提现审核中: "devUpdates.oct23WithdrawalUnderReview",
  审核不通过: "myWiki.status.rejected",
  正常金额: "devUpdates.oct23NormalAmount",
  未知业务: "devUpdates.oct23UnknownBusiness",
  未知方向: "devUpdates.oct23UnknownDirection",
  商品出售: "devUpdates.oct23ProductSale",
  自身充值: "devUpdates.oct23SelfDeposit",
  系统赠送: "devUpdates.oct23SystemGrant",
  购买商品: "devUpdates.oct23ProductPurchase",
  余额提现: "devUpdates.oct23BalanceWithdrawal",
  请选择审核结果: "devUpdates.oct23SelectReview",
  请输入还款金额: "devUpdates.oct23EnterRepayment",
  请选择提现币种: "devUpdates.oct23SelectWithdrawalCurrencyRequired",
  文件上传中: "devUpdates.oct23FileUploading",
  "开始与{name}的对话": "devUpdates.startAConversationWithName",
  "发送中...": "devUpdates.sending",
  发送失败: "devUpdates.failedToSend",
  "输入消息...": "devUpdates.typeAMessage",
  "正在加载产品…": "devUpdates.loadingProducts",
  营业执照有效期: "devUpdates.businessLicenseValidity",
  "保存中...": "devUpdates.saving",
  收起输入框: "devUpdates.collapseInput",
  展开输入框: "devUpdates.expandInput",
  相机取景: "devUpdates.cameraPreview",
  确认拍摄照片: "devUpdates.confirmCapturedPhoto",
  拍照识别: "devUpdates.recognizeAPhoto",
  确认照片: "devUpdates.confirmPhoto",
  松手取消: "devUpdates.releaseToCancel",
  "松手发送，上移取消": "devUpdates.releaseToSendSlideUpToCancel",
  已绑定: "devUpdates.linked",
  待绑定: "devUpdates.notLinked",
  收起卖方信息: "devUpdates.hideSellerInformation",
  查看更多卖方信息: "devUpdates.moreSellerInformation",
  收起买方信息: "devUpdates.hideBuyerInformation",
  查看更多买方信息: "devUpdates.moreBuyerInformation",
  订单审核人: "devUpdates.orderReviewer",
  合同审核人: "devUpdates.contractReviewer",
  供应商附件: "devUpdates.supplierAttachments",
  收起销售订单信息: "devUpdates.hideSalesOrderInformation",
  收起采购订单信息: "devUpdates.hidePurchaseOrderInformation",
  更多采购订单信息: "devUpdates.morePurchaseOrderInformation",
  收起更多信息: "devUpdates.hideAdditionalInformation",
  展开更多信息: "devUpdates.showAdditionalInformation",
  暂无税号: "devUpdates.noTaxId",
  未填写产品: "devUpdates.productNotSpecified",
  暂无负责人: "devUpdates.noPersonInCharge",
  按商定: "devUpdates.asAgreed",
  "货主：": "devUpdates.seller",
  订单总额超出: "devUpdates.orderTotalExceeded",
  订单总额未支付: "devUpdates.orderTotalUnpaid",
  香港账户: "devUpdates.hongKongAccount",
  境内账户: "devUpdates.mainlandChinaAccount",
  秒后重新发送: "devUpdates.secondsBeforeResending",
  暂无审批备注: "devUpdates.noApprovalNotes",
  交易过: "devUpdates.previouslyTraded",
  未交易: "devUpdates.noPreviousTrades",
  第: "devUpdates.ordinalPrefix",
  期: "devUpdates.installment",
  搜索审核人: "devUpdates.searchReviewers",
  审核人: "devUpdates.reviewer",
  上传本期支付凭证: "devUpdates.uploadThisInstallmentsPaymentReceipt",
  "（已确认）": "devUpdates.confirmed",
  "（未确认）": "devUpdates.unconfirmed",
  付款方式附件上传: "devUpdates.uploadPaymentMethodAttachments",
  截标审核: "devUpdates.bidClosingReview",
  发布信息: "devUpdates.publicationInformation",
  截标信息: "devUpdates.bidClosingInformation",
  单条发布: "devUpdates.singlePublication",
  竞标审核明细: "devUpdates.biddingReviewDetails",
  截标审核明细: "devUpdates.bidClosingReviewDetails",
  保存验货记录: "devUpdates.saveInspectionRecord",
  验货审核: "devUpdates.inspectionReview",
  批量确认验货: "devUpdates.confirmInspectionsInBulk",
  确认验货: "devUpdates.confirmInspection",
  已上传资料: "devUpdates.uploadedDocuments",
  "正在生成百科内容...": "devUpdates.generatingWikiContent",
  "AI 百科问答": "devUpdates.aiWikiQA",
  百科问答: "devUpdates.wikiQA",
  条问答: "devUpdates.qAEntries",
  个讨论: "devUpdates.discussions",
  "正在根据百科栏目生成问答…": "devUpdates.generatingQAFromWikiSections",
  "依据规格说明、技术特点、应用领域和使用注意事项":
    "devUpdates.basedOnSpecificationsTechnicalFeaturesApplicationsAndPrecautions",
  "暂未找到该产品讨论，正在展示热门问答":
    "devUpdates.noDiscussionsForThisProductPopularQAIsShownInstead",
  当前产品讨论: "devUpdates.currentProductDiscussions",
  审核付款凭证: "devUpdates.reviewPaymentReceipt",
  审核付款方式: "devUpdates.reviewPaymentMethod",
  选择付款方式: "devUpdates.selectPaymentMethod",
  付款凭证审核人: "devUpdates.paymentReceiptReviewer",
  付款方式审核人: "devUpdates.paymentMethodReviewer",
  "只支持jpg、png、gif、bmp格式的图片":
    "devUpdates.onlyJpgPngGifAndBmpImagesAreSupported",
  图片大小不能超过10M: "devUpdates.imagesMustNotExceed10Mb",
  只支持图片: "devUpdates.onlyImagesAreSupported",
  图片不能超过10M: "devUpdates.imageSizeLimit",
  请先选择图片或输入文字信息: "devUpdates.selectAnImageOrEnterTextFirst",
  接口请求失败: "devUpdates.requestFailed",
  图片选择组件未加载: "devUpdates.theImagePickerIsNotReady",
  "只支持pdf、png、jpg格式的文件":
    "devUpdates.onlyPdfPngAndJpgFilesAreSupported",
  文件大小不能超过10M: "devUpdates.filesMustNotExceed10Mb",
  "只支持png、jpg格式的图片": "devUpdates.onlyPngAndJpgImagesAreSupported",
  "识别成功 ✅": "devUpdates.recognitionSucceeded",
  已复制: "devUpdates.copied",
  "绑定商品成功!": "devUpdates.productLinkedSuccessfully",
  当前页面仅支持采购订单审核和采购合同审批:
    "devUpdates.thisPageSupportsPurchaseOrderAndPurchaseContractReviewOnly",
  获取审批节点状态失败: "devUpdates.failedToLoadApprovalStatus",
  请先上传合同文件: "devUpdates.uploadTheContractFileFirst",
  "合同文件未发生变更，无需上传":
    "devUpdates.theContractFileIsUnchangedNoUploadIsNeeded",
  关联内容已更新: "devUpdates.relatedContentUpdated",
  移除成功: "devUpdates.removedSuccessfully",
  发起合同审批成功: "devUpdates.contractApprovalRequested",
  请填写驳回理由: "devUpdates.enterTheRejectionReason",
  无法识别的下载响应类型: "devUpdates.unsupportedDownloadResponse",
  文件下载完成: "devUpdates.fileDownloaded",
  "下载失败，服务器返回了错误":
    "devUpdates.downloadFailedTheServerReturnedAnError",
  付款审核成功: "devUpdates.paymentApproved",
  付款申请已驳回: "devUpdates.paymentRequestRejected",
  缺少合同ID参数: "devUpdates.contractIdIsMissing",
  加载合同数据失败: "devUpdates.failedToLoadContractData",
  "客户已上传单章合同文件，不能再切换该选项":
    "devUpdates.theCustomerUploadedASingleStampedContractThisOptionCannotBeChanged",
  合同模板和单章合同只能选择一种发起审批:
    "devUpdates.chooseEitherAContractTemplateOrASingleStampedContractForApproval",
  请先上传合同模板或单章合同:
    "devUpdates.uploadAContractTemplateOrASingleStampedContractFirst",
  模板内容为空: "devUpdates.theTemplateIsEmpty",
  模板已保存: "devUpdates.templateSaved",
  模板保存失败: "devUpdates.failedToSaveTemplate",
  该审核人已添加: "devUpdates.thisReviewerHasAlreadyBeenAdded",
  请先上传INV发票: "devUpdates.uploadTheInvInvoiceFirst",
  发起INV审批成功: "devUpdates.invApprovalRequested",
  INV审核成功: "devUpdates.invApproved",
  初始化货主公司失败: "devUpdates.failedToInitializeTheSellerCompany",
  银行添加成功: "devUpdates.bankAddedSuccessfully",
  图片大小不能超过10MB: "devUpdates.imageFileSizeLimit",
  已移除关联内容: "devUpdates.relatedContentRemoved",
  发起付款审批成功: "devUpdates.paymentApprovalRequested",
  合并成功: "devUpdates.mergedSuccessfully",
  搜索公司列表失败: "devUpdates.failedToSearchCompanies",
  获取公司列表失败: "devUpdates.failedToLoadCompanies",
  公司资料添加成功: "devUpdates.companyProfileAdded",
  地址添加成功: "devUpdates.addressAdded",
  地址更换成功: "devUpdates.addressChanged",
  请先输入搜索关键词: "devUpdates.enterASearchKeywordFirst",
  当前订单暂不可生成销售订单:
    "devUpdates.aSalesOrderCannotBeGeneratedForThisOrderYet",
  请选择至少一个卖方审核人: "devUpdates.selectAtLeastOneSellerReviewer",
  请选择卖方公司: "devUpdates.selectTheSellerCompany",
  货物情况必填: "devUpdates.productConditionIsRequired",
  "表单验证失败，请检查输入项": "devUpdates.validationFailedCheckTheFormFields",
  请选择产品价格单位: "devUpdates.selectThePriceCurrency",
  订单合同生成成功: "devUpdates.orderContractGenerated",
  "缺少订单ID，无法驳回": "devUpdates.orderIdIsMissingTheOrderCannotBeRejected",
  加载数据失败: "devUpdates.failedToLoadData",
  分批付款合计不能超过应付金额:
    "devUpdates.installmentsCannotExceedTheAmountDue",
  每次只能添加一期未支付的分期批次:
    "devUpdates.onlyOneUnpaidInstallmentCanBeAddedAtATime",
  "未支付总额为0，不能继续添加分期":
    "devUpdates.theUnpaidBalanceIsZeroNoMoreInstallmentsCanBeAdded",
  最多支持5期分期付款: "devUpdates.upToFiveInstallmentsAreSupported",
  请填写第一期的付款金额和付款时间:
    "devUpdates.enterTheFirstInstallmentAmountAndPaymentDate",
  "发起付款方式审批成功，开始付款方式审核":
    "devUpdates.paymentMethodSubmittedForReview",
  请上传支付凭证: "devUpdates.uploadAPaymentReceipt",
  "提交成功，已流转至采购商务：黄心雨": "devUpdates.submittedToPurchasingTeam",
  付款凭证已确认: "devUpdates.paymentReceiptConfirmed",
  付款方式审核通过: "devUpdates.paymentMethodApproved",
  请输入正确的手机验证码: "devUpdates.enterAValidMobileVerificationCode",
  "你确认要退出登录吗？": "devUpdates.areYouSureYouWantToLogOut",
  已取消退出: "devUpdates.logoutCancelled",
  绑定成功: "devUpdates.linkedSuccessfully",
  银行信息已复制: "devUpdates.bankDetailsCopied",
  银行列表加载失败: "devUpdates.failedToLoadBanks",
  绑定银行已更新: "devUpdates.linkedBanksUpdated",
  绑定银行更新失败: "devUpdates.failedToUpdateLinkedBanks",
  供应商列表加载失败: "devUpdates.failedToLoadSuppliers",
  供应商资料加载失败: "devUpdates.failedToLoadSupplierProfile",
  新建银行成功: "devUpdates.bankCreated",
  加载竞标信息失败: "devUpdates.failedToLoadBiddingInformation",
  请先选择公司名称: "devUpdates.selectACompanyFirst",
  银行资料已新增并自动回填:
    "devUpdates.bankDetailsAddedAndFilledInAutomatically",
  添加公司失败: "devUpdates.failedToAddCompany",
  批量上传功能开发中: "devUpdates.batchUploadIsComingSoon",
  请选择所货地: "devUpdates.selectTheProductLocation",
  请选择发布时间: "devUpdates.selectThePublicationDate",
  请选择截标时间: "devUpdates.selectTheBiddingDeadline",
  请选择开标时间: "devUpdates.selectTheBidOpeningTime",
  请先上传Excel文件: "devUpdates.uploadAnExcelFileFirst",
  "批量发布失败，请稍后重试": "devUpdates.batchPublicationFailedTryAgainLater",
  "只支持 .xlsx 和 .xls 格式的文件":
    "devUpdates.onlyXlsxAndXlsFilesAreSupported",
  无法读取Excel工作表: "devUpdates.cannotReadTheExcelWorksheet",
  Excel文件为空: "devUpdates.theExcelFileIsEmpty",
  Excel文件没有数据: "devUpdates.theExcelFileContainsNoData",
  '未找到有效的竞标数据，请确保Excel包含"料号"列':
    "devUpdates.biddingImportPartNumberColumnRequired",
  读取文件失败: "devUpdates.failedToReadFile",
  请至少填写一项信息: "devUpdates.completeAtLeastOneField",
  请选择包装: "devUpdates.selectPackaging",
  请选择封装: "devUpdates.selectAPackage",
  "确认上传合同？上传后不能再修改编辑":
    "devUpdates.uploadThisContractItCannotBeEditedAfterTheOtherPartyApprovesIt",
  关联订单添加成功: "devUpdates.relatedOrdersAdded",
  "确认双章合同审核通过？":
    "devUpdates.approveDualStampedContractConfirmation",
  双章合同审核通过: "devUpdates.dualStampedContractApproved",
  "确认发起INV审批？": "devUpdates.requestInvApproval",
  "操作成功！": "devUpdates.operationSucceeded",
  请填写必填字段: "devUpdates.completeTheRequiredFields",
  报价成功: "devUpdates.quoteSubmitted",
  已移除关联订单: "devUpdates.relatedOrderRemoved",
  单个订单不需要合并: "devUpdates.aSingleOrderDoesNotNeedMerging",
  请选择需要合并的订单: "devUpdates.selectOrdersToMerge",
  "请检查必填项！": "devUpdates.checkTheRequiredFields",
  "确认提交付款方式审批？提交后将进入审核流程。":
    "devUpdates.submitThePaymentMethodForReview",
  付款凭证已驳回: "devUpdates.paymentReceiptRejected",
  "确认付款凭证无误？确认后供应商可查看下载付款凭证":
    "devUpdates.confirmThePaymentReceiptIsCorrectTheSupplierCanThenViewAndDownloadIt",
  "确认通过付款方式审核？": "devUpdates.approveThePaymentMethod",
  付款方式已驳回: "devUpdates.paymentMethodRejected",
  请输入企业邮箱: "devUpdates.enterTheBusinessEmail",
  请填写账号和密码: "devUpdates.enterTheAccountAndPassword",
  请阅读并同意相关协议: "devUpdates.readAndAcceptTheAgreements",
  "密码长度需为6-20位": "devUpdates.thePasswordMustContain620Characters",
  请填写企业全称: "devUpdates.enterTheFullCompanyName",
  竞标审核数据读取失败: "devUpdates.failedToLoadBiddingReviewData",
  "审核明细加载失败，请稍后重试":
    "devUpdates.failedToLoadReviewDetailsTryAgainLater",
  "该入仓记录已保存，确认删除吗？":
    "devUpdates.thisWarehouseReceiptHasBeenSavedDeleteIt",
  请先填写所有入仓记录的日期和入仓号:
    "devUpdates.enterDatesAndReceiptNumbersForAllWarehouseReceipts",
  "图片或视频上传中，请稍后再切换商品":
    "devUpdates.imagesOrVideosAreUploadingWaitBeforeSwitchingProducts",
  缺少商品编号: "devUpdates.productNumberIsMissing",
  请至少选择一个商品: "devUpdates.selectAtLeastOneProduct",
  "图片或视频上传中，请稍后确认验货":
    "devUpdates.imagesOrVideosAreUploadingWaitBeforeConfirmingInspection",
  当前角色不能保存验货图片和条款:
    "devUpdates.yourRoleCannotSaveInspectionImagesOrTerms",
  每项入仓实际数量都必须大于0:
    "devUpdates.eachWarehouseReceiptQuantityMustBeGreaterThanZero",
  验货数量不能为空: "devUpdates.inspectionQuantityIsRequired",
  当前商品保存成功: "devUpdates.currentProductSaved",
  当前状态不允许确认验货:
    "devUpdates.theCurrentStatusDoesNotAllowInspectionConfirmation",
  请填写审批备注: "devUpdates.enterApprovalNotes",
  "确认验货成功！": "devUpdates.inspectionConfirmed",
  当前状态不允许驳回: "devUpdates.theCurrentStatusDoesNotAllowRejection",
  请填写驳回原因: "devUpdates.rejectionReasonRequired",
  "驳回成功！": "devUpdates.rejectedSuccessfully",
  警告: "devUpdates.warning",
  请先勾选商品规格: "devUpdates.selectProductSpecificationsFirst",
  所选商品规格库存不足:
    "devUpdates.insufficientStockForTheSelectedSpecifications",
  "撤回后，该词条将停止审核并保存为仅你可见的草稿。之后可以继续编辑或删除草稿。":
    "devUpdates.withdrawingStopsReviewAndSavesAPrivateDraftYouCanThenEditOrDeleteIt",
  确认撤回投稿: "devUpdates.confirmWithdrawal",
  "投稿已撤回并保存为草稿，不再进入审核队列":
    "devUpdates.submissionWithdrawnAndSavedAsADraftOutsideTheReviewQueue",
  "删除后，该草稿将从“我的发布”中移除，且无法由你恢复。":
    "devUpdates.deletingRemovesThisDraftFromMyPublicationsAndCannotBeUndone",
  确认删除草稿: "devUpdates.confirmDraftDeletion",
  草稿已删除: "devUpdates.draftDeleted",
  "该来源暂未关联可打开的规格书 PDF":
    "devUpdates.noReadableDatasheetPdfIsLinkedToThisSource",
  请先登录后再查看完整规格书: "devUpdates.logInToViewTheFullDatasheet",
  "知识库详情加载失败，请稍后重试":
    "devUpdates.failedToLoadKnowledgeBaseDetailsTryAgainLater",
  词条名称已复制: "devUpdates.entryNameCopied",
  "历史版本加载失败，请稍后重试":
    "devUpdates.failedToLoadVersionHistoryTryAgainLater",
  暂无已发布的历史版本: "devUpdates.noPublishedHistoricalVersions",
  当前账号没有百科审核权限: "devUpdates.thisAccountCannotReviewWikiEntries",
  "真实人工复核记录只能选择审核通过、退回修改或审核不通过":
    "devUpdates.aManualReviewMustApproveReturnForRevisionOrReject",
  请先登录后再收藏: "devUpdates.logInBeforeSaving",
  暂无可下载的规格书: "devUpdates.noDatasheetsAvailableToDownload",
  "该规格书暂不支持受保护下载，请从知识库产品页下载":
    "devUpdates.protectedDownloadIsUnavailableDownloadFromTheKnowledgeBaseProductPage",
  请先登录后再下载规格书: "devUpdates.logInToDownloadTheDatasheet",
  "暂时无法获取下载积分，请稍后重试":
    "devUpdates.cannotLoadDownloadCreditsTryAgainLater",
  确认下载规格书: "devUpdates.confirmDatasheetDownload",
  "规格书下载服务暂不可用，请稍后重试":
    "devUpdates.datasheetDownloadsAreUnavailableTryAgainLater",
  "规格书下载中（管理员无限次免费下载）":
    "devUpdates.downloadingDatasheetUnlimitedFreeDownloadsForAdministrators",
  "规格书下载中（已购规格书，本次不扣积分）":
    "devUpdates.downloadingAPurchasedDatasheetNoCreditsDeducted",
  数据导出已开始: "devUpdates.dataExportStarted",
  "百科产品加载失败，请稍后重试":
    "devUpdates.failedToLoadWikiProductsTryAgainLater",
  "加载更多产品失败，请稍后重试":
    "devUpdates.failedToLoadMoreProductsTryAgainLater",
  "规格书仅支持 PDF 格式": "devUpdates.datasheetsMustBePdfFiles",
  "规格书不能超过 50MB": "devUpdates.datasheetsMustNotExceed50Mb",
  "每个百科词条只能上传一份规格书，请先移除已选文件":
    "devUpdates.eachWikiEntryAllowsOneDatasheetRemoveTheSelectedFileFirst",
  加载计划发布内容失败: "devUpdates.failedToLoadScheduledPublication",
  立即发布失败: "devUpdates.immediatePublicationFailed",
  取消计划发布: "devUpdates.cancelScheduledPublication",
  "计划发布已取消，词条已保存为草稿":
    "devUpdates.scheduledPublicationCancelledTheEntryWasSavedAsADraft",
  取消计划发布失败: "devUpdates.failedToCancelScheduledPublication",
  暂不支持该文件格式: "devUpdates.thisFileFormatIsNotSupported",
  没有识别到可发布的百科内容: "devUpdates.noPublishableWikiContentRecognized",
  "文件解析失败，请检查文件内容":
    "devUpdates.fileParsingFailedCheckTheFileContents",
  请填写必填项: "devUpdates.requiredFieldsMissing",
  请选择晚于当前时间的计划发布时间: "devUpdates.selectAFuturePublicationTime",
  "上传的 PDF 疑似包含广告或导流内容，请更换为合规的官方规格书":
    "devUpdates.datasheetPromotionalContentWarning",
  "上传的 PDF 与芯片规格资料无关，请重新选择对应型号的规格书":
    "devUpdates.thePdfIsUnrelatedToChipSpecificationsSelectTheDatasheetForThisPart",
  "该 PDF 暂时无法提取原文，提交后将转人工复核，不能自动发布":
    "devUpdates.datasheetTextExtractionManualReviewHint",
  请至少填写一条百科内容: "devUpdates.addAtLeastOneWikiEntry",
  "本批存在提交失败的内容，已停止后续提交并保留未完成数据，请检查后重试":
    "devUpdates.batchSubmissionStoppedOnFailure",
  回答已删除: "devUpdates.answerDeleted",
  评论已删除: "devUpdates.commentDeleted",
  评论已发布: "devUpdates.commentPublished",
  新建公司资料: "devUpdates.newCompanyProfile",
  "录入公司基础资料、证照与绑定信息，用于采购订单主体选择":
    "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsForPurchaseOrders",
  大陆企业: "devUpdates.mainlandChinaCompany",
  港澳台企业: "devUpdates.hongKongMacaoOrTaiwanCompany",
  请输入文本或粘贴图片内容: "devUpdates.enterTextOrPasteAnImage",
  供应商简称: "devUpdates.supplierShortName",
  请填写供应商简称: "devUpdates.enterTheSupplierShortName",
  "请填写公司名称(英)": "devUpdates.enterTheCompanyNameInEnglish",
  公司编码: "devUpdates.companyCode",
  请填写公司编码: "devUpdates.enterTheCompanyCode",
  公司法人: "devUpdates.legalRepresentative",
  请填写公司法人: "devUpdates.enterTheLegalRepresentative",
  搜索绑定公司: "devUpdates.searchLinkedCompanies",
  未找到匹配的公司: "devUpdates.noMatchingCompanies",
  请填写公司地址: "devUpdates.enterTheCompanyAddress",
  请填写公司电话: "devUpdates.enterTheCompanyPhoneNumber",
  绑定银行: "devUpdates.linkedBankAccounts",
  无可绑定的银行: "devUpdates.noBankAccountsAvailableToLink",
  上传框架协议: "devUpdates.uploadAFrameworkAgreement",
  上传供应商调查表: "devUpdates.uploadASupplierQuestionnaire",
  上传审计报告: "devUpdates.uploadAnAuditReport",
  提交公司资料: "devUpdates.submitCompanyProfile",
  公司税号及大陆银行信息: "devUpdates.taxIdAndMainlandChinaBankDetails",
  登记号及境外银行信息: "devUpdates.registrationNumberAndOverseasBankDetails",
  待识别图片预览: "devUpdates.imagePreviewForRecognition",
  移除待识别图片: "devUpdates.removeImageForRecognition",
  公司属性: "devUpdates.companyAttributes",
  主公司: "devUpdates.parentCompany",
  搜索需要绑定的公司: "devUpdates.searchCompaniesToLink",
  可多选: "devUpdates.multipleSelectionsAllowed",
  "· 已选": "devUpdates.selected",
  项: "devUpdates.items",
  暂无可绑定银行: "devUpdates.noLinkableBankAccounts",
  选择绑定公司: "devUpdates.selectCompaniesToLink",
  搜索公司名称: "devUpdates.searchCompanyNames",
  "录入公司基础资料、证照与绑定信息，用于供应商资料管理":
    "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsToManageSuppliers",
  "智能识别（支持pdf,png,jpg图片格式）":
    "devUpdates.smartRecognitionPdfPngAndJpg",
  请输入文本或粘贴公司资料内容: "devUpdates.enterTextOrPasteCompanyDetails",
  公司所在地: "devUpdates.companyLocation",
  "请选择国家/省/市/区": "devUpdates.selectCountryProvinceCityAndDistrict",
  报告年份: "devUpdates.reportYear",
  请选择年份: "devUpdates.selectAYear",
  搜索历史会话: "devUpdates.searchPastConversations",
  "搜索...": "devUpdates.search",
  新建对话: "devUpdates.newConversation",
  未找到相关会话: "devUpdates.noMatchingConversations",
  回到先搜AI: "devUpdates.backToXsouAi",
  前往个人主页: "devUpdates.goToProfile",
  "扫一扫（开发中）": "devUpdates.scanComingSoon",
  开发中: "devUpdates.comingSoon",
  "提醒（开发中）": "devUpdates.remindersComingSoon",
  "设置（开发中）": "devUpdates.settingsComingSoon",
  会话操作: "devUpdates.conversationActions",
  编辑对话名称: "devUpdates.renameConversation",
  从对话列表删除: "devUpdates.removeFromConversations",
  对话名称: "devUpdates.conversationName",
  查找聊天内容: "devUpdates.findInConversation",
  清空搜索内容: "devUpdates.clearSearch",
  取消查找: "devUpdates.cancelSearch",
  输入关键词查找当前对话: "devUpdates.enterAKeywordToSearchThisConversation",
  当前对话中未找到相关内容: "devUpdates.noMatchingContentInThisConversation",
  历史会话: "devUpdates.pastConversations",
  "内容由 AI 生成": "devUpdates.aiGeneratedContent",
  "语音通话（开发中）": "devUpdates.voiceCallComingSoon",
  "扬声器（开发中）": "devUpdates.speakerComingSoon",
  当前会话操作: "devUpdates.currentConversationActions",
  创建新对话: "devUpdates.createAConversation",
  搜索关键词和参考资料: "devUpdates.searchKeywordsAndReferences",
  回复操作: "devUpdates.responseActions",
  复制回复: "devUpdates.copyResponse",
  "朗读（开发中）": "devUpdates.readAloudComingSoon",
  "朗读回复（开发中）": "devUpdates.readResponseAloudComingSoon",
  "收藏（开发中）": "devUpdates.saveComingSoon",
  "收藏回复（开发中）": "devUpdates.saveResponseComingSoon",
  "分享（开发中）": "devUpdates.shareComingSoon",
  "分享回复（开发中）": "devUpdates.shareResponseComingSoon",
  "重新生成（开发中）": "devUpdates.regenerateComingSoon",
  "重新生成回复（开发中）": "devUpdates.regenerateResponseComingSoon",
  正在生成: "devUpdates.generating",
  回到最新消息: "devUpdates.goToLatestMessage",
  "拍照或上传附件（开发中）": "devUpdates.takeAPhotoOrUploadAFileComingSoon",
  "发消息...": "devUpdates.sendAMessage",
  "语音输入（开发中）": "devUpdates.voiceInputComingSoon",
  "添加（开发中）": "devUpdates.addComingSoon",
  取消上传: "devUpdates.cancelUpload",
  待上传的芯片照片: "devUpdates.chipPhotoToUpload",
  拍照: "devUpdates.takeAPhoto",
  重新拍照: "devUpdates.retakePhoto",
  确认上传: "devUpdates.confirmUpload",
  参考链接: "devUpdates.references",
  "仅显示本次答案实际引用的资料。":
    "devUpdates.onlySourcesCitedInThisResponseAreShown",
  主要导航: "devUpdates.mainNavigation",
  竞价: "devUpdates.bidding",
  切换语言: "devUpdates.changeLanguage",
  庆祝中华人民共和国成立:
    "devUpdates.celebratingTheFoundingOfThePeoplesRepublicOfChina",
  周年: "devUpdates.anniversary",
  快捷型号搜索: "devUpdates.quickPartNumberSearch",
  快捷搜索: "devUpdates.quickSearch",
  "Copyright © 2017-2026 先搜科技 (":
    "devUpdates.copyright20172026XsouTechnology",
  关闭节日祝福: "devUpdates.closeHolidayGreeting",
  XSOU节日标志: "devUpdates.xsouHolidayLogo",
  "该商品已绑定，请勿重复绑定": "devUpdates.thisProductIsAlreadyLinked",
  "请先登录，再绑定商品": "devUpdates.logInBeforeLinkingTheProduct",
  确认绑定: "devUpdates.confirmLinking",
  发起合同审批步骤: "devUpdates.contractApprovalSteps",
  复制邀请货主链接: "devUpdates.copySellerInvitationLink",
  "商品料号：": "devUpdates.partNumber",
  "商品ID：": "devUpdates.productId",
  订单附件: "devUpdates.orderAttachments",
  个: "devUpdates.files",
  关联内容: "devUpdates.relatedContent",
  货主审核人: "devUpdates.sellerReviewer",
  暂无货主审核人: "devUpdates.noSellerReviewers",
  添加审核人: "devUpdates.addReviewer",
  暂未添加审核人: "devUpdates.noReviewersAdded",
  下载合同模版: "devUpdates.downloadContractTemplate",
  生成PO采购订单: "devUpdates.generatePoPurchaseOrder",
  生成PI形式发票: "devUpdates.generatePiProFormaInvoice",
  生成PL装箱单: "devUpdates.generatePlPackingList",
  生成INV合同: "devUpdates.generateInvContract",
  生成送货单: "devUpdates.generateDeliveryNote",
  生成销售合同: "devUpdates.generateSalesContract",
  由供应商上传单章合同文件: "devUpdates.supplierUploadsASingleStampedContract",
  添加关联内容: "devUpdates.addRelatedContent",
  暂未关联内容: "devUpdates.noRelatedContentAdded",
  查看资料: "devUpdates.viewDocuments",
  资料: "devUpdates.documents",
  上一步: "devUpdates.previous",
  下一步: "devUpdates.next",
  未找到匹配的抄送人: "devUpdates.noMatchingCcRecipients",
  资料详情: "devUpdates.documentDetails",
  关闭资料详情: "devUpdates.closeDocumentDetails",
  销售订单商品: "devUpdates.salesOrderProducts",
  暂时无法查看该页面: "devUpdates.thisPageIsCurrentlyUnavailable",
  正在加载付款信息: "devUpdates.loadingPaymentInformation",
  付款备注: "devUpdates.paymentNotes",
  付款申请备注: "devUpdates.paymentRequestNotes",
  付款审批流程: "devUpdates.paymentApprovalWorkflow",
  返回订单: "devUpdates.backToOrder",
  暂无关联内容: "devUpdates.noRelatedContent",
  采购订单商品: "devUpdates.purchaseOrderProducts",
  INV审核人: "devUpdates.invReviewer",
  采购订单填写步骤: "devUpdates.purchaseOrderSteps",
  切换账号: "devUpdates.switchAccount",
  选择商品提供人: "devUpdates.selectProductProvider",
  添加采购商品: "devUpdates.addPurchaseProduct",
  请填写产品品牌名称: "devUpdates.enterTheProductBrand",
  请填写产品料号: "devUpdates.enterThePartNumber",
  请填写产品单价: "devUpdates.enterTheUnitPrice",
  "产品数量/单位": "devUpdates.quantityUnit",
  请填写采购数量: "devUpdates.enterThePurchaseQuantity",
  产品单位: "devUpdates.productUnit",
  请填写产品总价: "devUpdates.enterTheProductTotal",
  请填写交货地区: "devUpdates.enterTheDeliveryRegion",
  "请输入批次(DC)": "devUpdates.enterTheDateCodeDc",
  "货物情况（多选）": "devUpdates.productConditionMultipleSelections",
  "暂无采购商品，请在采购设置中添加":
    "devUpdates.noPurchaseProductsAddProductsInPurchaseSettings",
  合同编号在选择卖方公司后自动生成:
    "devUpdates.theContractNumberIsGeneratedAfterSelectingTheSellerCompany",
  允许重复: "devUpdates.duplicatesAllowed",
  请选择交货日期: "devUpdates.selectADeliveryDate",
  按照商定: "devUpdates.asNegotiated",
  请选择采购谈判人: "devUpdates.selectAPurchaseNegotiator",
  预估佣金: "devUpdates.estimatedCommission",
  请填写预估佣金: "devUpdates.enterTheEstimatedCommission",
  请填写售后条款: "devUpdates.enterTheAfterSalesTerms",
  请填写订单备注: "devUpdates.enterOrderNotes",
  请选择或填写公司名称: "devUpdates.selectOrEnterTheCompanyName",
  新建: "devUpdates.create",
  请填写详细地址: "devUpdates.enterTheFullAddress",
  请填写银行英文名称: "devUpdates.enterTheBankNameInEnglish",
  请填写银行中文名称: "devUpdates.enterTheBankNameInChinese",
  请填写开户银行: "devUpdates.enterTheAccountBank",
  请填写银行账号: "devUpdates.enterTheBankAccountNumber",
  "请填写 Swift Code": "devUpdates.enterTheSwiftCode",
  "请填写 Bank Code": "devUpdates.enterTheBankCode",
  银中地址: "devUpdates.bankAddressChinese",
  请填写银行中文地址: "devUpdates.enterTheBankAddressInChinese",
  银英地址: "devUpdates.bankAddressEnglish",
  请填写银行英文地址: "devUpdates.enterTheBankAddressInEnglish",
  请填写收货地址: "devUpdates.enterTheShippingAddress",
  订单提交操作: "devUpdates.orderSubmission",
  采购报价: "devUpdates.purchaseQuote",
  生成订单: "devUpdates.generateOrder",
  选择交货日期: "devUpdates.selectDeliveryDate",
  选择采购谈判人: "devUpdates.selectPurchaseNegotiator",
  搜索采购谈判人: "devUpdates.searchPurchaseNegotiators",
  未找到匹配的谈判人: "devUpdates.noMatchingNegotiators",
  输入姓名搜索采购谈判人: "devUpdates.enterANameToSearchPurchaseNegotiators",
  公司列表: "devUpdates.companies",
  共: "devUpdates.total",
  家: "devUpdates.companyCountUnit",
  暂无公司资料: "devUpdates.noCompanyProfiles",
  正在加载订单信息: "devUpdates.loadingOrderInformation",
  发起付款审批: "devUpdates.requestPaymentApproval",
  销售订单填写步骤: "devUpdates.salesOrderSteps",
  请选择产品品牌: "devUpdates.selectTheProductBrand",
  请填写销售数量: "devUpdates.enterTheSalesQuantity",
  请选择交货地区: "devUpdates.selectTheDeliveryRegion",
  请选择销售谈判人: "devUpdates.selectASalesNegotiator",
  清除销售谈判人: "devUpdates.clearSalesNegotiator",
  请选择公司名称: "devUpdates.selectACompany",
  请填写主联系人: "devUpdates.enterThePrimaryContact",
  更换: "devUpdates.change",
  清除卖方联系人: "devUpdates.clearSellerContact",
  清除卖方联系电话: "devUpdates.clearSellerPhoneNumber",
  请填写卖方公司税号: "devUpdates.enterTheSellerTaxId",
  请选择银行: "devUpdates.selectABank",
  请填写开户支行: "devUpdates.enterTheBankBranch",
  请填写联行号: "devUpdates.enterTheBankRoutingNumber",
  清除买方联系人: "devUpdates.clearBuyerContact",
  清除买方联系电话: "devUpdates.clearBuyerPhoneNumber",
  请填写买方公司税号: "devUpdates.enterTheBuyerTaxId",
  请选择收货地址: "devUpdates.selectAShippingAddress",
  销售订单提交操作: "devUpdates.salesOrderSubmission",
  选择合并订单: "devUpdates.mergeOrderSelection",
  选择销售谈判人: "devUpdates.selectSalesNegotiator",
  搜索谈判人: "devUpdates.searchNegotiators",
  谈判人列表: "devUpdates.negotiators",
  人: "devUpdates.people",
  暂无谈判人数据: "devUpdates.noNegotiators",
  确认订单信息: "devUpdates.confirmOrderInformation",
  订单汇总: "devUpdates.orderSummary",
  合同与交付: "devUpdates.contractAndDelivery",
  返回修改: "devUpdates.backToEdit",
  订购详情: "devUpdates.purchaseDetails",
  交易信息: "devUpdates.tradeInformation",
  订购数量: "devUpdates.purchaseQuantity",
  买家微信: "devUpdates.buyerWechat",
  订购时间: "devUpdates.orderTime",
  产品资料: "devUpdates.productDocuments",
  货主微信: "devUpdates.sellerWechat",
  谈判人手机号: "devUpdates.negotiatorPhoneNumber",
  生成合同: "devUpdates.generateContract",
  生成交易合同: "devUpdates.generateTradeContract",
  成交价: "devUpdates.tradePrice",
  成交数量: "devUpdates.tradeQuantity",
  买家成单费用: "devUpdates.buyerTransactionFee",
  货主成单费用: "devUpdates.sellerTransactionFee",
  商品金额: "devUpdates.productAmount",
  应付金额: "devUpdates.amountDue",
  只读: "devUpdates.readOnly",
  本次付款金额: "devUpdates.paymentAmount",
  提交后将按订单应付总额一次性完成付款:
    "devUpdates.submittingPaysTheFullAmountDueInOnePayment",
  完结订单: "devUpdates.completeOrder",
  删除该期: "devUpdates.deleteInstallment",
  分期名称: "devUpdates.installmentName",
  请输入分期名称: "devUpdates.enterTheInstallmentName",
  本期申请支付金额: "devUpdates.requestedInstallmentAmount",
  请输入付款金额: "devUpdates.enterThePaymentAmount",
  占比: "devUpdates.percentage",
  付款时间: "devUpdates.paymentDate",
  请选择付款时间: "devUpdates.selectAPaymentDate",
  请选择下单公司: "devUpdates.selectTheOrderingCompany",
  付款银行: "devUpdates.paymentBank",
  请选择付款银行: "devUpdates.selectAPaymentBank",
  添加分期: "devUpdates.addInstallment",
  "每次仅可新增 1 期": "devUpdates.onlyOneInstallmentCanBeAddedAtATime",
  订单总额: "devUpdates.orderTotal",
  订单总额已支付: "devUpdates.orderTotalPaid",
  收款账户: "devUpdates.receivingAccount",
  同步附件: "devUpdates.syncAttachments",
  付款方式附件: "devUpdates.paymentMethodAttachments",
  付款方式备注: "devUpdates.paymentMethodNotes",
  请填写付款方式备注: "devUpdates.enterPaymentMethodNotes",
  "订单号：": "devUpdates.orderNumber",
  本期应付金额: "devUpdates.installmentAmountDue",
  通过审核: "devUpdates.approve",
  提交付款凭证: "devUpdates.submitPaymentReceipt",
  确认付款凭证: "devUpdates.confirmPaymentReceipt",
  选择付款日期: "devUpdates.selectPaymentDate",
  选择下单公司: "devUpdates.selectOrderingCompany",
  输入公司名称进行模糊查询: "devUpdates.enterACompanyNameToSearch",
  "查询中...": "devUpdates.searching",
  暂无匹配公司: "devUpdates.matchingCompanyListEmpty",
  选择付款银行: "devUpdates.selectPaymentBank",
  暂无付款银行: "devUpdates.noPaymentBanks",
  驳回付款方式: "devUpdates.rejectPaymentMethod",
  海报: "devUpdates.poster",
  免密登录: "devUpdates.passwordlessLogin",
  微信二维码: "devUpdates.wechatQrCode",
  "打开微信扫一扫，快速登录/注册": "devUpdates.scanWithWechatToLogInOrSignUp",
  "登录/注册即代表同意": "devUpdates.byLoggingInOrSigningUpYouAgreeTo",
  与: "devUpdates.and",
  "订单金额：": "devUpdates.orderAmount",
  "创建时间：": "devUpdates.created",
  交易详情内容待补充完整: "devUpdates.tradeDetailsAreIncomplete",
  "类型：": "devUpdates.type",
  暂无内容: "devUpdates.noContent",
  余: "devUpdates.remaining",
  验货流程: "devUpdates.inspectionWorkflow",
  商务验货: "devUpdates.businessInspection",
  监督确认: "devUpdates.supervisorConfirmation",
  验货完成: "devUpdates.inspectionCompleted",
  商品目录: "devUpdates.productDirectory",
  个商品: "devUpdates.products",
  批量操作: "devUpdates.batchActions",
  "驳回原因：": "devUpdates.rejectionReason",
  验货信息加载失败: "devUpdates.failedToLoadInspectionInformation",
  未入仓数量: "devUpdates.quantityNotReceived",
  已入仓数量: "devUpdates.quantityReceived",
  入仓明细: "devUpdates.warehouseReceiptDetails",
  添加入仓: "devUpdates.addWarehouseReceipt",
  同步其他商品: "devUpdates.syncOtherProducts",
  入仓日期: "devUpdates.warehouseReceiptDate",
  入仓号: "devUpdates.warehouseReceiptNumber",
  请输入入仓号: "devUpdates.enterTheWarehouseReceiptNumber",
  实际数量: "devUpdates.actualQuantity",
  删除入仓记录: "devUpdates.deleteWarehouseReceipt",
  验货资料: "devUpdates.inspectionDocuments",
  上传中: "devUpdates.uploading",
  未拆封细节: "devUpdates.unopenedProductDetails",
  未拆封包装: "devUpdates.unopenedPackaging",
  "图 ·": "devUpdates.photos",
  已拆封细节: "devUpdates.openedProductDetails",
  补充验货条款: "devUpdates.additionalInspectionTerms",
  请输入补充验货条款: "devUpdates.enterAdditionalInspectionTerms",
  审批备注: "devUpdates.approvalNotes",
  正在加载验货信息: "devUpdates.loadingInspectionInformation",
  填写驳回原因: "devUpdates.enterRejectionReason",
  请输入具体原因: "devUpdates.enterTheReason",
  确认驳回: "devUpdates.confirmRejection",
  请输入供应商名称: "devUpdates.enterTheSupplierName",
  新增: "devUpdates.add",
  绑定银行筛选: "devUpdates.filterByLinkedBank",
  全部银行: "devUpdates.allBanks",
  供应商列表: "devUpdates.suppliers",
  重置筛选: "devUpdates.resetFilters",
  主公司名称: "devUpdates.parentCompanyName",
  联系信息: "devUpdates.contactInformation",
  供应商银行信息: "devUpdates.supplierBankDetails",
  个账户: "devUpdates.accounts",
  子公司名称: "devUpdates.subsidiaryName",
  商业登记证: "devUpdates.businessRegistrationCertificate",
  审计报告: "devUpdates.auditReport",
  采购协议: "devUpdates.purchaseAgreement",
  调查表: "devUpdates.questionnaire",
  "建档日期：": "devUpdates.profileCreatedLabel",
  "到期：": "devUpdates.expires",
  暂无供应商数据: "devUpdates.noSuppliers",
  新增供应商: "devUpdates.addSupplier",
  供应商操作: "devUpdates.supplierActions",
  新建银行: "devUpdates.addBank",
  新增地址: "devUpdates.addAddress",
  更换地址: "devUpdates.changeAddress",
  删除供应商: "devUpdates.deleteSupplier",
  供应商详情: "devUpdates.supplierDetails",
  资料文件: "devUpdates.documentFiles",
  联系人信息: "devUpdates.contactDetails",
  银行名称: "devUpdates.bankName",
  暂无供应商银行信息: "devUpdates.noSupplierBankDetails",
  暂未绑定银行: "devUpdates.noLinkedBanks",
  子公司信息: "devUpdates.subsidiaryInformation",
  交易状态: "devUpdates.tradeStatus",
  暂无子公司信息: "devUpdates.noSubsidiaries",
  选择该供应商可使用的我方银行账户:
    "devUpdates.selectOurBankAccountsAvailableToThisSupplier",
  暂无可绑定的银行: "devUpdates.bankAccountLinkOptionsEmpty",
  保存绑定: "devUpdates.saveLinkedAccounts",
  选择银行: "devUpdates.selectBank",
  当前公司暂无银行资料: "devUpdates.noBankDetailsForThisCompany",
  竞标发布: "devUpdates.publishBidding",
  返回竞标: "devUpdates.backToBidding",
  批量上传: "devUpdates.batchUpload",
  隐私保护: "devUpdates.privacyProtection",
  "+ 新建公司资料": "devUpdates.createCompanyProfileAction",
  请填写收款账号: "devUpdates.enterTheReceivingAccountNumber",
  信息发布者: "devUpdates.publisher",
  请选择业务组人员: "devUpdates.selectABusinessTeamMember",
  选择26年的第几周: "devUpdates.selectAWeekIn2026",
  选择状态: "devUpdates.selectStatus",
  所货地: "devUpdates.productLocation",
  选择地区: "devUpdates.selectRegion",
  原封: "devUpdates.factorySealed",
  其它: "devUpdates.other",
  请填写备注信息: "devUpdates.enterNotes",
  详细信息: "devUpdates.details",
  "商品ID/链接": "devUpdates.productIdLink",
  请填写商品ID或链接: "devUpdates.enterTheProductIdOrLink",
  "规格书 / 数据手册": "devUpdates.specificationDatasheet",
  批量上传Excel文件: "devUpdates.uploadExcelFilesInBulk",
  "将Excel文件拖到此处，或": "devUpdates.dropAnExcelFileHereOr",
  "支持 .xlsx, .xls 格式": "devUpdates.supportsXlsxAndXls",
  已解析: "devUpdates.parsed",
  条数据: "devUpdates.records",
  还有: "devUpdates.remainingPrefix",
  "条数据...": "devUpdates.moreRecords",
  标单: "devUpdates.bidLot",
  编码: "devUpdates.code",
  请填写编码: "devUpdates.enterTheCode",
  选择产品分类: "devUpdates.selectProductCategory",
  请填写容量: "devUpdates.enterCapacity",
  选择封装: "devUpdates.selectPackage",
  选择技术: "devUpdates.selectTechnology",
  请填写库存: "devUpdates.enterStockQuantity",
  选择包装: "devUpdates.packagingSelection",
  "该商品已绑定，请勿重复绑定商品":
    "devUpdates.duplicateProductBindingNotAllowed",
  请先: "devUpdates.pleaseFirstPrefix",
  "，再绑定商品": "devUpdates.beforeLinkingTheProduct",
  "发布时间：": "devUpdates.published",
  供需发布: "devUpdates.publishSupplyDemand",
  品牌入驻: "devUpdates.registerABrand",
  "视图：": "devUpdates.view",
  "品牌分类：": "devUpdates.brandCategory",
  "地区：": "devUpdates.region",
  "排序：": "devUpdates.sort",
  产品数: "devUpdates.productCount",
  热度: "devUpdates.popularity",
  成立年份: "devUpdates.founded",
  企业数: "devUpdates.companyCount",
  订单数: "devUpdates.orders",
  查看产品: "devUpdates.viewProducts",
  品牌名: "devUpdates.brandName",
  品牌简介: "devUpdates.brandIntroduction",
  已生效: "devUpdates.active",
  暂无相关品牌信息: "devUpdates.noMatchingBrands",
  商品明细: "devUpdates.productDetails",
  "同一产品可添加不同品牌、料号、数量和单价":
    "devUpdates.addDifferentBrandsPartNumbersQuantitiesAndUnitPrices",
  添加商品: "devUpdates.addProduct",
  "单价：": "devUpdates.unitPrice",
  暂无订单附件: "devUpdates.noOrderAttachments",
  发起合同审批信息: "devUpdates.contractApprovalInformation",
  合同审批信息: "devUpdates.contractApprovalOverview",
  "补充付款、审核人与合同文件信息":
    "devUpdates.completePaymentReviewerAndContractFileInformation",
  审批与关联: "devUpdates.approvalAndRelatedContent",
  移除审核人: "devUpdates.removeReviewer",
  合同文件: "devUpdates.contractFiles",
  下载合同模板: "devUpdates.downloadContractTemplateAction",
  生成PO采购合同: "devUpdates.generatePoPurchaseContract",
  更多销售订单信息: "devUpdates.moreSalesOrderInformation",
  买方类型: "devUpdates.buyerType",
  收货人电话: "devUpdates.recipientPhoneNumber",
  总价: "devUpdates.totalPrice",
  更多资料: "devUpdates.moreDocuments",
  点击查看规格书: "devUpdates.viewSpecification",
  输入: "devUpdates.enter",
  姓名搜索并添加: "devUpdates.aNameToSearchAndAdd",
  无搜索结果: "devUpdates.noSearchResults",
  买卖双方资料: "devUpdates.buyerAndSellerInformation",
  "核对交易主体、银行资料及付款相关附件":
    "devUpdates.checkTradingPartiesBankDetailsAndPaymentAttachments",
  付款文件: "devUpdates.paymentDocuments",
  "集中查看交易合同，并上传付款流程所需文件":
    "devUpdates.viewTradeContractsAndUploadDocumentsRequiredForPayment",
  "交易合同（PO）": "devUpdates.tradeContractPo",
  商品与采购信息: "devUpdates.productAndPurchaseInformation",
  "确认商品提供人、谈判人和本次采购商品":
    "devUpdates.confirmTheProviderNegotiatorAndPurchaseProducts",
  请选择商品提供人: "devUpdates.selectAProductProvider",
  "完整展示商品交易字段，四列排布提升填写效率":
    "devUpdates.completeProductTradeFieldsArrangedInFourColumns",
  "确认合同编号、交货日期、订单类型与补充说明":
    "devUpdates.confirmContractNumberDeliveryDateOrderTypeAndNotes",
  请填写合同编号: "devUpdates.enterTheContractNumber",
  "完整展示卖方公司、联系人、地址与银行信息":
    "devUpdates.completeSellerCompanyContactAddressAndBankDetails",
  展开隐藏信息: "devUpdates.showHiddenInformation",
  请填写卖公司税号: "devUpdates.sellerCompanyTaxIdRequired",
  请填写银行名称: "devUpdates.enterTheBankName",
  "请填写Swift Code": "devUpdates.swiftCodeRequired",
  "请填写Bank Code": "devUpdates.bankCodeRequired",
  请填写银英地址: "devUpdates.bankEnglishAddressRequired",
  "完整展示买方公司、联系人与收货信息":
    "devUpdates.completeBuyerCompanyContactAndShippingDetails",
  请填写买公司税号: "devUpdates.buyerCompanyTaxIdRequired",
  补充本次采购订单申请备注: "devUpdates.addNotesForThisPurchaseOrderRequest",
  "确认信息后执行采购报价，报价完成后生成订单":
    "devUpdates.confirmInformationRequestAPurchaseQuoteThenGenerateTheOrder",
  "PI（形式发票）": "devUpdates.piProFormaInvoice",
  "CI（正式发票）": "devUpdates.ciCommercialInvoice",
  "数量(": "devUpdates.quantity",
  "勾选同一买方下的订单，合并后统一生成销售订单":
    "devUpdates.selectOrdersForTheSameBuyerToMergeIntoASalesOrder",
  "维护销售商品、价格、数量、交货地区与货物情况":
    "devUpdates.editSalesProductsPricesQuantitiesDeliveryRegionsAndConditions",
  请填写单位: "devUpdates.enterTheUnit",
  订单资料: "devUpdates.orderDocuments",
  "当前订单：": "devUpdates.currentOrder",
  已上传: "devUpdates.uploaded",
  "确认合同编号、交货日期、订单类型、谈判人、售后条款与付款方式":
    "devUpdates.confirmContractNumberDeliveryDateOrderTypeNegotiatorAfterSalesTermsAndPaymentMethod",
  补充本次销售订单申请备注: "devUpdates.addNotesForThisSalesOrderRequest",
  采购商务点击采购报价后即可生成销售订单:
    "devUpdates.thePurchasingTeamCanGenerateASalesOrderAfterRequestingAQuote",
  "订单 / 合同信息": "devUpdates.orderContractInformation",
  交易双方: "devUpdates.tradingParties",
  展开交易双方: "devUpdates.showTradingParties",
  全额支付: "devUpdates.payInFull",
  分批支付: "devUpdates.payInInstallments",
  付完完结订单: "devUpdates.completeOrderAfterFullPayment",
  请输入下单公司查询: "devUpdates.enterTheOrderingCompanyToSearch",
  审核单号: "devUpdates.reviewNumber",
  本单料号: "devUpdates.partNumbersInThisReview",
  库存合计: "devUpdates.totalStock",
  料号数量: "devUpdates.partNumberCount",
  入选用户: "devUpdates.selectedParticipants",
  汇总数量: "devUpdates.totalQuantity",
  结算金额: "devUpdates.settlementAmount",
  竞标规则: "devUpdates.biddingRules",
  发布状态: "devUpdates.publicationStatus",
  佣金方式: "devUpdates.commissionMethod",
  佣金比例: "devUpdates.commissionRate",
  参与等级: "devUpdates.participationLevel",
  发布公司: "devUpdates.publishingCompany",
  提交方式: "devUpdates.submissionMethod",
  发布备注: "devUpdates.publicationNotes",
  料号信息: "devUpdates.partNumberInformation",
  商品属性: "devUpdates.productAttributes",
  库存与包装: "devUpdates.stockAndPackaging",
  所在地与货况: "devUpdates.locationAndCondition",
  正在加载更多审核明细: "devUpdates.loadingMoreReviewDetails",
  回到页面顶部: "devUpdates.backToTop",
  每页: "devUpdates.perPage",
  "所货地：": "devUpdates.productLocationLabel",
  "装箱：": "devUpdates.packaging",
  "库存：": "devUpdates.stock",
  "入选用户：": "devUpdates.selectedParticipantsLabel",
  "提交：": "devUpdates.submitted",
  入选竞标用户: "devUpdates.selectedBidders",
  "确认最低价：": "devUpdates.confirmedMinimumPrice",
  "汇总数量：": "devUpdates.totalQuantityLabel",
  "费用方式：": "devUpdates.feeMethod",
  审核流程: "devUpdates.reviewWorkflow",
  请填写本次审核备注: "devUpdates.enterReviewNotes",
  正在加载审核明细: "devUpdates.loadingReviewDetails",
  未找到该审核单: "devUpdates.reviewNotFound",
  返回审核列表: "devUpdates.backToReviews",
  请核对全部: "devUpdates.pleaseCheckAll",
  信息后确认审核: "devUpdates.informationBeforeConfirmingTheReview",
  商品规格: "devUpdates.productSpecifications",
  页面路径: "devUpdates.pagePath",
  验货进度: "devUpdates.inspectionProgress",
  产品信息与入仓记录: "devUpdates.productInformationAndWarehouseReceipts",
  "· 自动汇总": "devUpdates.automaticallyTotaled",
  统一: "devUpdates.applyToAll",
  请输入实际数量: "devUpdates.enterTheActualQuantity",
  "· 视频": "devUpdates.videos",
  暂无视频: "devUpdates.noVideos",
  请填写补充验货条款: "devUpdates.additionalInspectionTermsRequired",
  请输入具体的驳回原因: "devUpdates.enterSpecificRejectionReason",
  "管理供应商信息及联系人、银行、地址等资料":
    "devUpdates.manageSupplierProfilesContactsBanksAndAddresses",
  请选择绑定银行: "devUpdates.selectLinkedBankAccounts",
  采购框架协议: "devUpdates.purchaseFrameworkAgreement",
  复制供应商银行信息: "devUpdates.copySupplierBankDetails",
  子公司明细: "devUpdates.subsidiaryDetails",
  到期日期: "devUpdates.expiryDate",
  我方绑定银行: "devUpdates.ourLinkedBankAccounts",
  建档日期: "devUpdates.profileCreated",
  供应商调查表: "devUpdates.supplierQuestionnaire",
  新建地址: "devUpdates.createAddress",
  "银行 logo": "devUpdates.bankLogo",
  家子公司: "devUpdates.subsidiaries",
  个银行账户: "devUpdates.bankAccounts",
  请输入公司编码: "devUpdates.companyCodePlaceholder",
  请输入公司法人: "devUpdates.legalRepresentativePlaceholder",
  公司联系人: "devUpdates.companyContact",
  请输入公司联系人: "devUpdates.enterTheCompanyContact",
  请输入联系方式: "devUpdates.enterContactDetails",
  详细地址: "devUpdates.fullAddress",
  请输入详细地址: "devUpdates.fullAddressPlaceholder",
  请输入银行名称: "devUpdates.bankNamePlaceholder",
  请输入收款账号: "devUpdates.receivingAccountPlaceholder",
  开户行账号: "devUpdates.bankAccountNumber",
  请输入开户行账号: "devUpdates.bankAccountPlaceholder",
  银行地址: "devUpdates.bankAddress",
  请输入银行地址: "devUpdates.enterTheBankAddress",
  "请输入swift code": "devUpdates.swiftCodePlaceholder",
  "请输入bank code": "devUpdates.bankCodePlaceholder",
  请输入备注: "devUpdates.notesPlaceholder",
  "确 定": "devUpdates.confirm",
  "取 消": "devUpdates.cancel",
  在线咨询: "devUpdates.onlineInquiry",
  选择规格: "devUpdates.selectSpecifications",
  "剩余库存：": "devUpdates.remainingStock",
  "” 的智能搜索结果": "devUpdates.smartSearchResults",
  "答案由先搜AI实时生成，请结合产品规格书核验关键参数。":
    "devUpdates.generatedLiveByXsouAiVerifyKeyParametersAgainstTheProductDatasheet",
  找到: "devUpdates.found",
  "条与 “": "devUpdates.resultsFor",
  "” 相关的": "devUpdates.relatedSearchClosingQuote",
  结果: "devUpdates.results",
  "百科内容正在生成，完成后将自动显示。":
    "devUpdates.wikiContentIsBeingGeneratedAndWillAppearWhenReady",
  条回答: "devUpdates.answers",
  查看全部问答: "devUpdates.viewAllQA",
  关闭大图: "devUpdates.closeEnlargedImage",
  未找到对应芯片百科: "devUpdates.chipWikiEntryNotFound",
  返回百科列表: "devUpdates.backToChipWiki",
  由先搜AI实时生成: "devUpdates.generatedLiveByXsouAi",
});
export const devUpdateKey = (value) =>
  typeof value === "string" && Object.hasOwn(devUpdateKeyIndex, value)
    ? devUpdateKeyIndex[value]
    : null;

// 固定显示键映射和表单校验提示；不修改提交字段、业务正文或路由。
const fixedDisplayAliases = Object.freeze({
  "$(美元)": "devSync.usdCurrencyLabel",
  视频: "devSync.videos",
  产品厂家: "devSync.manufacturer",
  产品参数: "devSync.productParameters",
  产品尺寸: "devSync.productDimensions",
  产品数量和单位: "devSync.productQuantityAndUnit",
  产品编号: "devSync.productNumber",
  产品编码: "devSync.productCode",
  产品重量: "devSync.productWeight",
  产地证明: "devSync.certificateOfOrigin",
  会话名称已修改: "devSync.conversationRenamed",
  低沉: "devSync.deep",
  倍: "devSync.multiplierSymbol",
  免登录还可提问: "devSync.questionsRemainingWithoutSigningIn",
  入仓库存: "devSync.receivedStock",
  关闭声音设置: "devSync.closeVoiceSettings",
  出库仓库: "devSync.dispatchWarehouse",
  出库单信息: "devSync.dispatchOrderInformation",
  出库单号: "devSync.dispatchOrderNumber",
  出库单审核: "devSync.dispatchOrderReview",
  出库单审核人: "devSync.dispatchOrderReviewer",
  出库数量: "devSync.dispatchQuantity",
  出库日期: "devSync.dispatchDate",
  出库明细: "devSync.dispatchDetails",
  出库附件: "devSync.dispatchAttachments",
  删除入仓记录及验货细节: "devSync.deleteReceiptAndInspectionDetails",
  删除附件: "devSync.deleteAttachment",
  加入购物车成功: "devSync.addedToCart",
  半音: "devSync.semitones",
  发布类型: "devSync.publicationType",
  商品价格货币单位: "devSync.priceCurrency",
  "图片或视频上传中，请稍后操作":
    "devSync.imagesOrVideosAreUploadingPleaseWait",
  图片读取失败: "devSync.failedToReadTheImage",
  "声音加载中…": "devSync.loadingVoices",
  声音设置: "devSync.voiceSettings",
  "大宗发布功能正在准备中，敬请期待": "devSync.bulkPublicationIsComingSoon",
  审批编号: "devSync.approvalNumber",
  当前浏览器不支持录音: "devSync.thisBrowserDoesNotSupportRecording",
  当前浏览器不支持音高调节: "devSync.thisBrowserDoesNotSupportPitchAdjustment",
  "当前浏览器无法直接调用相机，已切换到系统拍照":
    "devSync.theCameraIsUnavailableInThisBrowserSwitchedToTheSystemCamera",
  快: "devSync.fast",
  恢复默认: "devSync.restoreDefaults",
  慢: "devSync.slow",
  所在部门: "devSync.department",
  按住下方语音按钮即可说话: "devSync.holdTheVoiceButtonBelowToSpeak",
  支持上传多个文件: "devSync.multipleFilesSupported",
  "文件上传中，请稍后切换商品":
    "devSync.filesAreUploadingPleaseWaitBeforeSwitchingProducts",
  新建产品信息: "devSync.createProductInformation",
  无法获取麦克风权限: "devSync.microphonePermissionUnavailable",
  明亮: "devSync.bright",
  暂无出库明细: "devSync.noDispatchDetails",
  "未识别到语音内容，请重试": "devSync.noSpeechDetectedPleaseTryAgain",
  "本次浏览期间保留，登录后可保存": "devSync.keptDuringThisVisitSignInToSave",
  "次 · 本次浏览期间保留，登录后可保存":
    "devSync.timesKeptDuringThisVisitSignInToSave",
  "正在加载资料…": "devSync.loadingInformation",
  添加明细: "devSync.addDetails",
  点击或拖拽上传附件: "devSync.clickOrDragFilesToUpload",
  "照片生成失败，请重新拍照": "devSync.failedToCaptureAPhotoPleaseTryAgain",
  登录后查看会话历史: "devSync.signInToViewConversationHistory",
  "相机尚未准备好，请稍后重试":
    "devSync.theCameraIsNotReadyPleaseTryAgainLater",
  "相机权限不可用，已切换到系统拍照":
    "devSync.cameraPermissionUnavailableSwitchedToTheSystemCamera",
  芯片类型: "devSync.chipType",
  "该入仓记录已保存，删除后对应的验货细节将一起删除，确认删除吗？":
    "devSync.thisReceiptIsSavedDeletingItAlsoDeletesItsInspectionDetailsContinue",
  语速: "devSync.speechSpeed",
  语音工具栏: "devSync.voiceToolbar",
  请填写主要联系人: "devSync.enterThePrimaryContact",
  请填写厂家名称: "devSync.enterTheManufacturer",
  "请填写批次(DC)": "devSync.enterTheDateCodeDc",
  请填写至少一条有效的入仓数量: "devSync.enterAtLeastOneValidReceivedQuantity",
  请输入产品名称搜索: "devSync.searchByProductName",
  请输入产品编码: "devSync.enterTheProductCode",
  请输入入仓库存: "devSync.enterReceivedStock",
  请输入出库单号: "devSync.enterTheDispatchOrderNumber",
  请输入出库单相关说明: "devSync.enterDispatchOrderNotes",
  请输入出库数量: "devSync.enterTheDispatchQuantity",
  请输入替代品牌: "devSync.enterAnAlternativeBrand",
  请输入替代料号: "devSync.enterAnAlternativePartNumber",
  "请选择 PDF 文件或图片": "devSync.selectAPdfFileOrImage",
  请选择入仓号: "devSync.selectAWarehouseReceiptNumber",
  请选择出库仓库: "devSync.selectADispatchWarehouse",
  请选择出库日期: "devSync.selectADispatchDate",
  资料暂时无法加载: "devSync.informationIsTemporarilyUnavailable",
  轮播图片: "devSync.carouselImage",
  选择出库仓库: "devSync.selectDispatchWarehouse",
  选择出库日期: "devSync.selectDispatchDate",
  选择声音: "devSync.selectAVoice",
  链接或id: "devSync.linkOrId",
  附件与备注: "devSync.attachmentsAndNotes",
  音高: "devSync.pitch",
  驳回销售单: "devSync.rejectSalesOrder",
  "验证码暂未接入，先填任意4位数字":
    "devSync.verificationIsNotIntegratedYetEnterAnyFourDigits",
  收货人: "devSync.recipient",
  收货电话: "devSync.recipientPhone",
  "登录失败，请检查账号信息": "devSync.loginFailedCheckYourAccountDetails",
  关闭自动播报: "devSync.turnOffAutomaticSpeech",
  开始自动播报: "devSync.turnOnAutomaticSpeech",
  朗读回复: "devSync.readReplyAloud",
  播放已生成的语音: "devSync.playGeneratedSpeech",
  "生成语音中，点击取消": "devSync.generatingSpeechClickToCancel",
  停止朗读: "devSync.stopReadingAloud",
  待监督确认: "devSync.awaitingSupervisorConfirmation",
  未加载: "devSync.notLoaded",
  暂无匹配商品: "devSync.noMatchingProducts",
  "搜索失败，请重新输入重试": "devSync.searchFailedEnterYourQueryAgain",
  "检索到 {files} 份资料 · {snippets} 个片段":
    "devSync.retrievedFilesDocumentsSnippetsSnippets",
  "声音列表加载失败，请重试": "devSync.failedToLoadVoicesPleaseTryAgain",
  "语音生成失败，请重试": "devSync.failedToGenerateSpeechPleaseTryAgain",
  "仅相关片段送入模型上下文，检索命中不代表最终引用": "devSync.snippetWarning",
  "候选资料已送入模型上下文，不代表最终引用": "devSync.candidateWarning",
  存储器: "wikiDisplay.category.memory",
  闪存: "pcFooter.flash",
  百科: "pcSearch.wiki",
  容量: "business.capacity",
  封装: "business.package",
  电压: "wikiDisplay.parameter.voltage",
  型号: "wikiDisplay.parameter.model",
  规格书: "wiki.detail.datasheet",
  百科正文: "wiki.entryBody",
  货物情况: "contractReview.goodsCondition",
  审核中: "contractReview.underReview",
  品牌管理: "personalMenu.brands",
  产品图片: "pcBrand.productImage",
  合作伙伴: "adminFlows.partner",
  取消: "business.cancel",
  确认: "priceChannel.quote.decision.ACCEPTED",
  深圳: "pcBrand.shenzhen",
  联系人: "contractReview.contact",
  联系电话: "contractReview.contactPhone",
  动态译文管理: "personalMenu.contentTranslation",
  生成失败: "contentTranslation.FAILED",
  登录: "common.login",
  中国大陆: "bidPage.locationMainland",
  确定: "mobileShopCart.confirm",
  拍照识别: "devUpdates.recognizeAPhoto",
  松手取消: "devUpdates.releaseToCancel",
  保存验货记录: "devUpdates.saveInspectionRecord",
  验货审核: "devUpdates.inspectionReview",
  批量确认验货: "devUpdates.confirmInspectionsInBulk",
  确认验货: "devUpdates.confirmInspection",
  百科问答: "devUpdates.wikiQA",
  选择付款方式: "devUpdates.selectPaymentMethod",
  获取审批节点状态失败: "devUpdates.failedToLoadApprovalStatus",
  请填写驳回理由: "devUpdates.enterTheRejectionReason",
  请阅读并同意相关协议: "devUpdates.readAndAcceptTheAgreements",
  请先填写所有入仓记录的日期和入仓号:
    "devUpdates.enterDatesAndReceiptNumbersForAllWarehouseReceipts",
  "图片或视频上传中，请稍后再切换商品":
    "devUpdates.imagesOrVideosAreUploadingWaitBeforeSwitchingProducts",
  缺少商品编号: "devUpdates.productNumberIsMissing",
  请至少选择一个商品: "devUpdates.selectAtLeastOneProduct",
  "图片或视频上传中，请稍后确认验货":
    "devUpdates.imagesOrVideosAreUploadingWaitBeforeConfirmingInspection",
  当前角色不能保存验货图片和条款:
    "devUpdates.yourRoleCannotSaveInspectionImagesOrTerms",
  每项入仓实际数量都必须大于0:
    "devUpdates.eachWarehouseReceiptQuantityMustBeGreaterThanZero",
  验货数量不能为空: "devUpdates.inspectionQuantityIsRequired",
  当前商品保存成功: "devUpdates.currentProductSaved",
  当前状态不允许确认验货:
    "devUpdates.theCurrentStatusDoesNotAllowInspectionConfirmation",
  请填写审批备注: "devUpdates.enterApprovalNotes",
  "确认验货成功！": "devUpdates.inspectionConfirmed",
  当前状态不允许驳回: "devUpdates.theCurrentStatusDoesNotAllowRejection",
  请填写驳回原因: "devUpdates.rejectionReasonRequired",
  "驳回成功！": "devUpdates.rejectedSuccessfully",
  当前账号没有百科审核权限: "devUpdates.thisAccountCannotReviewWikiEntries",
  竞价: "devUpdates.bidding",
  发起付款审批: "devUpdates.requestPaymentApproval",
  生成交易合同: "devUpdates.generateTradeContract",
  入仓号: "devUpdates.warehouseReceiptNumber",
  删除入仓记录: "devUpdates.deleteWarehouseReceipt",
  未拆封包装: "devUpdates.unopenedPackaging",
  确认驳回: "devUpdates.confirmRejection",
  竞标发布: "devUpdates.publishBidding",
  供需发布: "devUpdates.publishSupplyDemand",
  品牌入驻: "devUpdates.registerABrand",
  品牌: "nav.brands",
  收起: "wiki.collapse",
  展开: "wiki.expand",
  类型: "business.type",
  供应商: "pcTransaction.supplier",
  供需信息: "pcFooter.supplyDemand",
  "上传中...": "sourcePublish.uploading",
  上传成功: "sourcePublish.uploadSuccess",
  上传失败: "uploadLibrary.uploadFailed",
  请选择要上传的文件: "uploadLibrary.chooseFile",
  "文件上传中，请等待上传完成": "sourcePublish.waitUpload",
  导入成功: "sourcePublish.importSuccess",
  导入失败: "sourcePublish.importFailed",
  行情: "priceChannel.sectionNav.comparison",
  名称: "business.name",
  先搜AI: "nav.ai",
  供需: "nav.supply",
  精选: "nav.featured",
  芯片百科: "nav.wiki",
  商品图片: "pcCart.productImage",
  料号: "business.partNumber",
  搜索: "business.searchSuffix",
  "加载中...": "common.loading",
  "搜索中...": "supplyHall.searching",
  我的钱包: "wallet.title",
  账户余额: "account.balance",
  新对话: "pcAi.newChat",
  "历史加载中...": "pcAi.historyLoading",
  平台用户信息获取失败: "pcAi.userLoadFailed",
  "深圳先搜科技有限公司在哪里？": "pcAi.recommend1",
  帮我分析这个芯片型号是否可以替代: "pcAi.recommend2",
  "怎样判断一个料号属于哪个品牌？": "pcAi.recommend3",
  推荐几款常用的国产替代芯片: "pcAi.recommend4",
  "如何根据参数选择合适的电子元器件？": "pcAi.recommend5",
  帮我整理一份元器件采购询价需求: "pcAi.recommend6",
  "电子元器件选型时需要关注哪些参数？": "pcAi.recommend7",
  "如何识别并修正不规范的元器件料号？": "pcAi.recommend8",
  帮我比较两个芯片型号的主要区别: "pcAi.recommend9",
  "采购电子元器件时如何降低缺货风险？": "pcAi.recommend10",
  "如何判断不同封装型号能否通用？": "pcAi.recommend11",
  帮我解释常见芯片参数的含义: "pcAi.recommend12",
  规格书管理: "personalMenu.specifications",
  我的跟单: "personalMenu.myFollowUps",
  我的跟单员: "personalMenu.myFollowers",
  我的收藏: "priceChannel.myFavorites",
  分类: "wiki.category",
  客户: "adminFlows.customer",
  供应发布: "personalMenu.postSupply",
  需求发布: "personalMenu.postDemand",
  请输入: "sourcePublish.enter",
  确认发布: "sourcePublish.confirmPost",
  上传图片: "wiki.uploadImage",
  上传规格书: "sourcePublish.uploadDatasheet",
  备注: "contractReview.remarks",
  微信: "common.wechat",
  微博: "pcFooter.weibo",
  抖音: "mobile.product.douyin",
  小红书: "mobile.product.xiaohongshu",
  无: "contractReview.noTerms",
  替代产品: "adminFlows.alternativeProducts",
  快捷下单: "adminFlows.quickOrder",
  必填项: "orderDetail.required",
  请填写有效的数字: "sourcePublish.validNumber",
  "请先登录并且实名认证后再操作!": "pcProduct.loginAndVerifyFirst",
  复制成功: "contractReview.copySuccess",
  复制失败: "contractReview.copyFailed",
  首页: "nav.home",
  查看验货图片: "mobile.product.viewInspectionImages",
  长度: "adminFlows.length",
  宽度: "adminFlows.width",
  高度: "adminFlows.height",
  不能为空: "sourcePublish.required",
  客服: "common.agentService",
  在线: "agentServiceUI.online",
  温馨提示: "supplyHall.notice",
  去登录: "mobile.product.goToLogin",
  "提交订购意向成功！请等待商务接单！":
    "mobile.product.purchaseIntentSubmitted",
  我的购买订单: "buyOrders.title",
  标题: "business.title",
  上传付款凭证: "pcOrder.uploadPaymentProof",
  总客服: "agentServiceUI.generalDialog",
  安全设置: "personalMenu.security",
  个人资料: "personalMenu.personalInfo",
  账号认证: "personalMenu.verification",
  实名认证: "pcRealname.title",
  发布百科: "myWiki.publish",
  我的发布: "personalMenu.myPosts",
  词条名称: "wiki.entryName",
  词条释义: "wiki.entryDefinition",
  查看: "business.view",
  我的问答: "personalMenu.myQuestions",
  公司地址: "contractReview.companyAddress",
  公司名称: "contractReview.companyName",
  详情: "business.details",
  请选择: "sourcePublish.select",
  保存失败: "companyInfo.couldNotSave",
  请选择图片文件: "companyInfo.selectAnImageFile",
  "识别失败，请重试": "adminFlows.recognitionFailedPleaseTryAgain",
  未命名商品: "mobileShopCart.unnamedProduct",
  评价: "marketComponents.review",
  美元: "business.usd",
  人民币: "business.cny",
  商品: "mobileShopCart.product",
  商品列表: "mobile.search.productList",
  "请求异常！": "transactionDetail.requestError",
  "授权参数缺失，请重新授权": "transactionDetail.missingAuthCode",
  我的订单: "adminFlows.myOrders",
  其他: "wiki.otherInitial",
  供需大厅: "supplyHall.title",
  发布需求: "sourcePublish.postDemand",
  企业入驻: "supplyHall.join",
  "《网络安全法》规定，实名才可发布信息，前往实名认证！":
    "supplyHall.realnameNotice",
  前往实名认证: "supplyHall.goRealname",
  合同译文审核: "personalMenu.contractTranslation",
  精选交易: "account.featuredTrade",
  交易订单: "account.tradeOrders",
  商品中心: "account.goodsCenter",
  商品库: "account.goodsLibrary",
  供应商管理: "account.suppliers",
  消息管理: "account.messages",
  供应需求: "personalMenu.supplyDemand",
  简洁供应发布: "personalMenu.quickSupply",
  简洁需求发布: "personalMenu.quickDemand",
  批量发布: "personalMenu.bulkPost",
  客户管理: "adminFlows.customerManagement",
  我的客户: "adminFlows.myCustomers",
  会员等级: "adminFlows.membershipLevel",
  等级列表: "personalMenu.levelList",
  等级申请: "personalMenu.levelApplication",
  等级权益: "personalMenu.levelBenefits",
  会员身份: "priceChannel.memberIdentity",
  身份列表: "personalMenu.identityList",
  业务员: "adminFlows.salesperson",
  竞标管理: "business.biddingManagement",
  竞标审核: "personalMenu.bidReview",
  竞标列表: "business.biddingList",
  发布竞标: "business.publishBid",
  我的竞标: "business.myBids",
  知识百科: "personalMenu.wiki",
  审核管理: "personalMenu.reviewManagement",
  账号设置: "personalMenu.accountSettings",
  企业资料: "priceChannel.profile.title",
  价格频道: "priceChannel.channelName",
  请先登录: "common.loginRequired",
  "修改中...": "adminFlows.updating",
  "发布中...": "adminFlows.publishing",
  "商品明细为空，暂时无法下单":
    "adminFlows.noProductDetailsTheOrderCannotBePlaced",
  "部分商品规格已失效，请返回重新选择":
    "adminFlows.someProductSpecificationsAreNoLongerAvailableGoBackAndSelectAgain",
  "请填写完整的商品信息！": "adminFlows.completeTheProductInformation",
  修改成功: "business.changesSaved",
  专属订单: "adminFlows.privateOrder",
  请填写买家电话: "adminFlows.enterTheBuyerPhoneNumber",
  公开订单: "adminFlows.publicOrder",
  请选择产品分类: "sourcePublish.selectCategory",
  "（支持拖拽上传、拖拽排序，双击放大预览）":
    "adminFlows.dragToUploadOrReorderDoubleClickToPreview",
  上传产品图片: "sourcePublish.uploadProductImages",
  "（多选）": "adminFlows.multipleSelection",
  添加替代产品: "adminFlows.addAlternativeProduct",
  订单信息: "transactionDetail.orderInfo",
  精选发布页面: "adminFlows.publishFeaturedProduct",
  "选填已有信息，快速发布商品":
    "adminFlows.useAvailableDetailsToPublishAProductQuickly",
  编辑精选商品: "adminFlows.editFeaturedProduct",
  修改商品信息并提交审核: "adminFlows.updateProductDetailsAndSubmitForReview",
  确认修改: "business.confirmChanges",
  请输入正整数: "adminFlows.enterAPositiveInteger",
  请选择货物情况: "adminFlows.selectGoodsCondition",
  规格书附件: "sourcePublish.datasheetAttachment",
  "只支持 JPG、PNG、WEBP 图片":
    "adminFlows.onlyJpgPngAndWebpImagesAreSupported",
  "图片不能超过 10MB": "adminFlows.imageMustNotExceed10Mb",
  当前浏览器不支持语音识别:
    "adminFlows.speechRecognitionIsNotSupportedByThisBrowser",
  "语音识别失败，请重试": "adminFlows.speechRecognitionFailedPleaseTryAgain",
  请先输入文字或选择图片: "adminFlows.enterTextOrSelectAnImageFirst",
  未识别到可填充的产品信息: "adminFlows.noUsableProductInformationRecognized",
  识别并填充成功: "adminFlows.recognizedAndFilledSuccessfully",
  商品信息加载失败: "adminFlows.unableToLoadProductInformation",
  "商品信息加载失败，请稍后重试":
    "adminFlows.unableToLoadProductInformationPleaseTryAgain",
  "快捷下单成功！": "adminFlows.quickOrderCreated",
  "内容暂存成功！": "sourcePublish.draftSaved",
  请选择订单类型: "adminFlows.selectAnOrderType",
  请选择有效的订单类型: "adminFlows.selectAValidOrderType",
  发布成功: "sourcePublish.postSuccess",
  "请填写完整信息！": "sourcePublish.completeForm",
  请选择二级分类: "adminFlows.selectASubcategory",
  请填写替代品牌: "sourcePublish.enterAlternativeBrand",
  请填写替代料号: "sourcePublish.enterAlternativeModel",
  电脑: "adminFlows.computers",
  手机: "adminFlows.mobilePhones",
  汽车: "adminFlows.automotive",
  物联网: "adminFlows.iot",
  网络: "adminFlows.networking",
  中国香港: "bidPage.locationHongKong",
  关于先搜: "pcFooter.about",
  先搜科技: "pcFooter.company",
  发布: "nav.publish",
  审核通过: "contractReview.approveReview",
  我是货主: "business.sellerTitle",
  性格: "contactDialog.characterShort",
  爱好: "contactDialog.hobbiesShort",
  "拖拽排序，双击查看图片": "sourcePublish.imageHint",
  上传证明: "sourcePublish.uploadProof",
  暂未开放: "sourcePublish.notAvailable",
  我是买家: "personalOrderList.buyerTitle",
  芯片规格: "sourcePublish.chipSpecs",
  发布货源: "sourcePublish.postSupply",
  发布货源线索: "sourcePublish.postSupplyLead",
  "填写货源信息，发布货源线索": "sourcePublish.postSupplyHint",
  发布需求线索: "sourcePublish.postDemandLead",
  "填写需求信息，发布需求线索": "sourcePublish.postDemandHint",
  提交购买意向单: "sourcePublish.submitPurchaseIntent",
  失败: "wiki.failed",
  购物车: "mobileShopCart.cartTitle",
  申请成为谈判人: "transactionOrders.applyNegotiator",
  "提交中...": "realname.submitting",
  买家: "transactionDetail.buyerRole",
  货主: "business.seller",
  信息: "pcCsHome.information",
  产品类型: "priceChannel.spec.technology",
  处理中: "wallet.processing",
  提交采购意向: "mobileShopCart.submitPurchaseIntent",
  提交采购意向单: "mobileShopCart.checkoutTitle",
  "最多上传 10 个文件": "mobileShopCart.maxTenFiles",
  跟单: "transactionOrders.followUnit",
  销售订单: "pcTransaction.salesOrders",
  生成销售订单: "pcOrder.generateSalesOrder",
  上传交易合同: "contractReview.uploadTradeContract",
  上传单章合同: "contractReview.uploadSingle",
  上传双章合同: "contractReview.uploadDual",
  确认交易合同: "contractReview.confirmTradeContract",
  我的销售订单: "personalOrderList.saleTitle",
  已驳回: "contractReview.rejected",
  订单详情: "transactionDetail.title",
  我的: "nav.mine",
  包装: "business.packaging",
  产品型号: "priceChannel.spotBoard.model",
  提交时间: "priceChannel.certMaterials.submittedAt",
  先搜: "priceChannel.businessDisplay.subject.XSOU",
  商品订单详情: "preOrderDetail.title",
  附件: "contractReview.attachment",
  卖方信息: "contractReview.sellerInfo",
  买方信息: "contractReview.buyerInfo",
  芯片料号与描述不符: "transactionDetail.partMismatch",
  产品存在质量问题: "transactionDetail.qualityIssue",
  数量不足: "transactionDetail.shortQuantity",
  需要更换其他料号: "transactionDetail.differentPart",
  疑似假货: "transactionDetail.suspectedFake",
  添加图片: "wiki.addImage",
  暂无描述: "wiki.noDescription",
  发布说明: "wiki.publishReason",
  全部产品: "wiki.allProducts",
  推荐专题: "wiki.recommendedTopics",
  一: "wiki.ordinal1",
  二: "wiki.ordinal2",
  三: "wiki.ordinal3",
  四: "wiki.ordinal4",
  五: "wiki.ordinal5",
  六: "wiki.ordinal6",
  七: "wiki.ordinal7",
  用户问答: "wiki.userQnA",
  "审核认为内容需要修改，请完善后重新提交": "wiki.detail.needsRevision",
  "请输入 YYYY-MM-DD HH:mm 或 YYYY-MM-DD HH:mm:ss":
    "wiki.detail.scheduleFormat",
  已审核: "business.reviewed",
  我发布的线索: "business.myClues",
  产品介绍: "pcFooter.products",
  卖方: "contractReview.seller",
  买方: "contractReview.buyer",
  先款后货: "contractReview.payBeforeDelivery",
  先货后款: "contractReview.payAfterDelivery",
  待发起: "contractReview.notStarted",
  精选发布: "nav.mobileFeaturedPublish",
  好评等级1: "account.defaultReviewLevel",
  申请谈判人: "account.applyBroker",
  可提现: "account.withdrawable",
  冻结中: "account.frozen",
});
// 新合并的价格校验与入仓显示文案；仅映射固定文字，不改业务输入。
const mergedDisplayAliases = Object.freeze({
  最多4位小数: "devSync.priceMaxDecimals",
  请填写价格或金额: "devSync.priceRequired",
  请填写大于或等于0的值: "devSync.nonnegativePrice",
  请输入入仓号搜索: "devSync.searchWarehouseReceipt",
  暂无匹配入仓号: "devSync.noMatchingWarehouseReceipt",
  "查询失败，请重新输入入仓号重试": "devSync.warehouseReceiptSearchFailed",
  入仓仓库: "devSync.receivedWarehouse",
  "保存成功，明细刷新失败，请刷新页面后继续操作":
    "devSync.savedInspectionReloadFailed",
  "删除后该入仓明细及对应的验货细节将一起删除，确认删除吗？":
    "devSync.deleteReceiptDetailConfirmation",
});
export const devSyncMessageKey = (value) =>
  typeof value === "string" &&
  (Object.hasOwn(fixedDisplayAliases, value) ||
    Object.hasOwn(mergedDisplayAliases, value) ||
    Object.hasOwn(mobileWorkflowDisplayKeys, value))
    ? fixedDisplayAliases[value] || mergedDisplayAliases[value] || mobileWorkflowDisplayKeys[value]
    : null;
export default {
  watch: {
    "$store.state.locale.uiLocale"() {
      this.$nextTick(() => {
        for (const form of Object.values(this.$refs || {}))
          for (const field of form?.fields || [])
            if (field.validateState === "error") field.validate("", () => {});
      });
    },
  },
  methods: {
    // 校验提示在显示时投影；不改原规则、校验函数及表单提交值。
    devSyncRules(rules) {
      if (!rules || typeof rules !== "object") return rules;
      const project = (rule) =>
        rule && typeof rule === "object"
          ? {
              ...rule,
              message:
                typeof rule.message === "string"
                  ? this.devSyncText(rule.message)
                  : rule.message,
            }
          : rule;
      if (Array.isArray(rules)) return rules.map(project);
      if (
        ["message", "required", "validator", "pattern"].some((key) =>
          Object.hasOwn(rules, key)
        )
      )
        return project(rules);
      return Object.fromEntries(
        Object.entries(rules).map(([key, value]) => [
          key,
          this.devSyncRules(value),
        ])
      );
    },
    devSyncText(value) {
      const key = devSyncMessageKey(value);
      const projection = key ? null : mobileWorkflowDisplay(value, this.$store?.state?.locale?.uiLocale);
      return key ? this.$t(key) : projection ? this.$t(projection.key, projection.params) : value;
    },
    // 固定货况、地区与单位只在展示时翻译，表单及接口原值不变。
    productFact(value, field) {
      return productFactText(value, field, (key, params) => this.$t(key, params));
    },
    workflowNodeText(value) {
      return orderWorkflowNodeText(value, (key, params) => this.$t(key, params));
    },
    workflowItemCount(count) {
      return this.$t(Number(count) === 1 ? "mobileOrderWorkflow.itemCountOne" : "mobileOrderWorkflow.itemCountMany", { count });
    },
    workflowOptionLabel(option) {
      return this.devSyncText(typeof option === "object" && option !== null ? option.name ?? option.label : option);
    },
    orderFieldText(field) {
      if (field.label === "售后条款" && field.value === "无") return this.$t("contractReview.noTerms");
      const facts = { 货物情况: "condition", 品牌: "brand", 产品品牌: "brand", 交货地区: "location" };
      const kind = Object.hasOwn(facts, field.label) ? facts[field.label] : null;
      if (kind) return this.productFact(field.value, kind);
      return ["订单类型", "付款方式", "交货日期"].includes(field.label)
        ? this.devSyncText(field.value)
        : field.value;
    },
  },
};

export const UI_LOCALE_STORAGE_KEY = "xsou.ui-locale.v1";
export const isStaticI18nEnabled = (nodeEnv, flag) =>
  flag === "true" || (nodeEnv !== "production" && flag !== "false");
export const readInitialUiLocale = (storage, browserLanguage) => {
  try {
    const saved = normalizeUiLocale(storage?.getItem(UI_LOCALE_STORAGE_KEY));
    if (saved) return saved;
  } catch {}
  return normalizeUiLocale(browserLanguage) || "zh-CN";
};
export const saveUiLocale = (locale, storage) => {
  const normalized = normalizeUiLocale(locale);
  if (!normalized) return null;
  try {
    storage?.setItem(UI_LOCALE_STORAGE_KEY, normalized);
  } catch {}
  return normalized;
};

// 语言选择项保留各语言自称，不随界面语言重命名。

export const languageOptions = Object.freeze(
  Object.entries(simplified.languageNames).map(([locale, label]) =>
    Object.freeze({ locale, label, enabled: UI_LOCALES.includes(locale) })
  )
);

// 仅转换组件受控默认文案和人员角色；自定义标题、姓名、正文和提交值保持原样。
const mobileSharedKeys = Object.freeze({
  新建公司资料: "devUpdates.newCompanyProfile",
  暂无文件: "transactionDetail.noFiles",
  添加采购商品: "devUpdates.addPurchaseProduct",
  暂无可选择的采购商品: "workflowFeedback.noPurchases",
  确认选择: "uploadLibrary.confirmSelection",
  该商品不能取消选择: "workflowFeedback.lockedPurchase",
  添加抄送人: "contractReview.addCc",
  搜索抄送人姓名: "workflowFeedback.ccSearchPlaceholder",
  抄送人: "contractReview.cc",
  暂无可选抄送人: "workflowFeedback.noSelectableCc",
  上传文件: "companyInfo.uploadFile",
  输入公司名称查询: "companyDialogs.companySearchPlaceholder",
  选择产品分类: "devUpdates.selectProductCategory",
  请输入分类名称搜索: "sourcePublish.searchCategory",
  确认: "pcBrand.confirm",
  项目: "sharedUi.item",
  添加: "business.add",
  商品: "pcCsHome.products",
  人: "devUpdates.people",
  未命名银行: "companyDialogs.unnamedBank",
  货主: "business.seller",
  买家: "transactionDetail.buyerRole",
  采购商务: "business.purchaseBusiness",
  销售商务: "transactionDetail.salesBusiness",
  采购谈判人: "business.purchaseNegotiator",
  销售谈判人: "pcOrder.salesNegotiatorRole",
  验货人: "pcOrder.inspectorRole",
  文件: "companyInfo.file",
});
export function mobileSharedText(value) {
  const key =
    typeof value === "string" && Object.hasOwn(mobileSharedKeys, value)
      ? mobileSharedKeys[value]
      : null;
  // 按已登记的固定显示文案选择译文；未知内容原样保留。
  return key ? this.$t(key) : value;
}
